msgid ""
msgstr ""
"POT-Creation-Date: 2026-03-09 19:07+0000\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/components/account-block.jsx:143
msgid "Locked"
msgstr "Locked"

#. placeholder {0}: shortenNumber(statusesCount)
#: src/components/account-block.jsx:150
msgid "Posts: {0}"
msgstr "Posts: {0}"

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/account-block.jsx:155
msgid "Last posted: {0}"
msgstr "Last posted: {0}"

#: src/components/account-block.jsx:170
#: src/components/account-info.jsx:726
msgid "Automated"
msgstr "Automated"

#: src/components/account-block.jsx:177
#: src/components/account-info.jsx:731
#: src/components/status.jsx:605
msgid "Group"
msgstr "Group"

#: src/components/account-block.jsx:187
msgid "Mutual"
msgstr "Mutual"

#: src/components/account-block.jsx:191
#: src/components/related-actions.jsx:962
msgid "Requested"
msgstr "Requested"

#: src/components/account-block.jsx:195
#: src/components/related-actions.jsx:953
msgid "Following"
msgstr "Following"

#: src/components/account-block.jsx:199
#: src/components/related-actions.jsx:200
msgid "Follows you"
msgstr "Follows you"

#: src/components/account-block.jsx:207
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# follower} other {# followers}}"

#: src/components/account-block.jsx:216
#: src/components/account-info.jsx:774
msgid "Verified"
msgstr "Verified"

#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#: src/components/account-block.jsx:231
#: src/components/account-info.jsx:913
msgid "Joined <0>{0}</0>"
msgstr "Joined <0>{0}</0>"

#: src/components/account-handle-info.jsx:18
msgid "username"
msgstr "username"

#: src/components/account-handle-info.jsx:22
msgid "server domain name"
msgstr "server domain name"

#: src/components/account-info-mini.jsx:57
#: src/components/account-info.jsx:796
#: src/components/compose.jsx:2029
#: src/pages/settings.jsx:296
#: src/utils/visibility-text.jsx:7
msgid "Followers"
msgstr "Followers"

#: src/components/account-info-mini.jsx:61
#: src/components/account-info-mini.jsx:100
#: src/components/account-info.jsx:803
#: src/components/account-info.jsx:861
msgid "This user has chosen to not make this information available."
msgstr "This user has chosen to not make this information available."

#. placeholder {0}: shortenNumber(followersCount)
#. placeholder {1}: shortenNumber(followersCount)
#: src/components/account-info-mini.jsx:67
#: src/components/account-info.jsx:823
msgid "{followersCount, plural, one {<0>{0}</0> Follower} other {<1>{1}</1> Followers}}"
msgstr "{followersCount, plural, one {<0>{0}</0> Follower} other {<1>{1}</1> Followers}}"

#. js-lingui-explicit-id
#: src/components/account-info-mini.jsx:93
#: src/components/account-info.jsx:851
msgid "following.stats"
msgstr "Following"

#. placeholder {0}: shortenNumber(followingCount)
#: src/components/account-info-mini.jsx:106
#: src/components/account-info.jsx:867
msgid "{followingCount, plural, other {<0>{0}</0> Following}}"
msgstr "{followingCount, plural, other {<0>{0}</0> Following}}"

#. placeholder {0}: shortenNumber(statusesCount)
#. placeholder {1}: shortenNumber(statusesCount)
#: src/components/account-info-mini.jsx:119
#: src/components/account-info.jsx:891
msgid "{statusesCount, plural, one {<0>{0}</0> Post} other {<1>{1}</1> Posts}}"
msgstr "{statusesCount, plural, one {<0>{0}</0> Post} other {<1>{1}</1> Posts}}"

#: src/components/account-info.jsx:124
msgid "View profile"
msgstr "View profile"

#: src/components/account-info.jsx:392
msgid "Unable to load account."
msgstr "Unable to load account."

#: src/components/account-info.jsx:407
msgid "Go to account page"
msgstr "Go to account page"

#: src/components/account-info.jsx:462
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> has indicated that their new account is now:"

#: src/components/account-info.jsx:617
#: src/components/related-actions.jsx:530
msgid "Handle copied"
msgstr "Handle copied"

#: src/components/account-info.jsx:620
#: src/components/related-actions.jsx:533
msgid "Unable to copy handle"
msgstr "Unable to copy handle"

#: src/components/account-info.jsx:626
#: src/components/related-actions.jsx:539
msgid "Copy handle"
msgstr "Copy handle"

#: src/components/account-info.jsx:644
#: src/components/related-actions.jsx:255
#: src/components/related-actions.jsx:604
#: src/components/shortcuts-settings.jsx:1187
msgid "QR code"
msgstr "QR code"

#: src/components/account-info.jsx:650
msgid "Go to original profile page"
msgstr "Go to original profile page"

#: src/components/account-info.jsx:668
msgid "View profile image"
msgstr "View profile image"

#: src/components/account-info.jsx:686
msgid "View profile header"
msgstr "View profile header"

#: src/components/account-info.jsx:702
#: src/components/edit-profile-sheet.jsx:94
#: src/components/related-actions.jsx:856
msgid "Edit profile"
msgstr "Edit profile"

#: src/components/account-info.jsx:721
msgid "In Memoriam"
msgstr "In Memoriam"

#. placeholder {0}: ( postingStats.originals / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {1}: ( postingStats.replies / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {2}: ( postingStats.quotes / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {3}: ( postingStats.boosts / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#: src/components/account-info.jsx:948
msgid "{0} original posts, {1} replies, {2} quotes, {3} boosts"
msgstr "{0} original posts, {1} replies, {2} quotes, {3} boosts"

#. placeholder {0}: ( postingStats.originals / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {1}: ( postingStats.replies / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {2}: ( postingStats.boosts / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#: src/components/account-info.jsx:965
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} original posts, {1} replies, {2} boosts"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.daysSinceLastPost
#. placeholder {2}: postingStats.daysSinceLastPost
#. placeholder {3}: postingStats.daysSinceLastPost
#. placeholder {4}: postingStats.total
#. placeholder {5}: postingStats.total
#. placeholder {6}: postingStats.daysSinceLastPost
#: src/components/account-info.jsx:982
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.total
#: src/components/account-info.jsx:998
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"

#: src/components/account-info.jsx:1056
#: src/pages/catchup.jsx:73
#: src/pages/year-in-posts.jsx:1388
msgid "Original"
msgstr "Original"

#: src/components/account-info.jsx:1060
#: src/components/status.jsx:2733
#: src/pages/catchup.jsx:74
#: src/pages/catchup.jsx:1575
#: src/pages/catchup.jsx:2230
#: src/pages/status.jsx:1187
#: src/pages/status.jsx:1912
#: src/pages/year-in-posts.jsx:1392
msgid "Replies"
msgstr "Replies"

#: src/components/account-info.jsx:1065
#: src/components/quotes-modal.jsx:81
#: src/components/status.jsx:2738
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1578
#: src/pages/year-in-posts.jsx:1398
msgid "Quotes"
msgstr "Quotes"

#: src/components/account-info.jsx:1070
#: src/pages/catchup.jsx:76
#: src/pages/catchup.jsx:1577
#: src/pages/catchup.jsx:2242
#: src/pages/settings.jsx:1269
#: src/pages/year-in-posts.jsx:1404
msgid "Boosts"
msgstr "Boosts"

#: src/components/account-info.jsx:1076
msgid "Post stats unavailable."
msgstr "Post stats unavailable."

#: src/components/account-info.jsx:1103
msgid "View post stats"
msgstr "View post stats"

#: src/components/account-sheet.jsx:38
#: src/components/add-remove-lists-sheet.jsx:45
#: src/components/compose.jsx:1113
#: src/components/custom-emojis-modal.jsx:272
#: src/components/drafts.jsx:57
#: src/components/edit-profile-sheet.jsx:89
#: src/components/embed-modal.jsx:13
#: src/components/generic-accounts.jsx:151
#: src/components/gif-picker-modal.jsx:71
#: src/components/import-accounts-selection.jsx:81
#: src/components/import-export-accounts.jsx:108
#: src/components/keyboard-shortcuts-help.jsx:53
#: src/components/list-add-edit.jsx:37
#: src/components/media-alt-modal.jsx:43
#: src/components/media-attachment.jsx:385
#: src/components/media-modal.jsx:336
#: src/components/mention-modal.jsx:162
#: src/components/notification-service.jsx:157
#: src/components/open-link-sheet.jsx:51
#: src/components/post-embed-modal.jsx:196
#: src/components/private-note-sheet.jsx:36
#: src/components/qr-code-modal.jsx:33
#: src/components/qr-scanner-modal.jsx:257
#: src/components/quote-chain-modal.jsx:102
#: src/components/quote-settings-sheet.jsx:61
#: src/components/quotes-modal.jsx:76
#: src/components/report-modal.jsx:118
#: src/components/shortcuts-settings.jsx:278
#: src/components/shortcuts-settings.jsx:631
#: src/components/shortcuts-settings.jsx:891
#: src/components/status.jsx:3391
#: src/components/status.jsx:3603
#: src/components/translated-bio-sheet.jsx:21
#: src/pages/accounts.jsx:45
#: src/pages/catchup.jsx:1712
#: src/pages/filters.jsx:225
#: src/pages/list.jsx:302
#: src/pages/notifications.jsx:1035
#: src/pages/scheduled-posts.jsx:288
#: src/pages/settings.jsx:100
#: src/pages/status.jsx:1651
msgid "Close"
msgstr "Close"

#: src/components/add-remove-lists-sheet.jsx:50
#: src/components/related-actions.jsx:480
#: src/components/related-actions.jsx:490
msgid "Add/Remove from Lists"
msgstr "Add/Remove from Lists"

#: src/components/add-remove-lists-sheet.jsx:90
msgid "Unable to remove from list."
msgstr "Unable to remove from list."

#: src/components/add-remove-lists-sheet.jsx:91
msgid "Unable to add to list."
msgstr "Unable to add to list."

#: src/components/add-remove-lists-sheet.jsx:110
#: src/pages/lists.jsx:131
msgid "Unable to load lists."
msgstr "Unable to load lists."

#: src/components/add-remove-lists-sheet.jsx:114
msgid "No lists."
msgstr "No lists."

#: src/components/add-remove-lists-sheet.jsx:125
#: src/components/list-add-edit.jsx:41
#: src/pages/lists.jsx:62
msgid "New list"
msgstr "New list"

#: src/components/background-service.jsx:160
msgid "Cloak mode disabled"
msgstr "Cloak mode disabled"

#: src/components/background-service.jsx:160
msgid "Cloak mode enabled"
msgstr "Cloak mode enabled"

#. More from [Author]
#: src/components/byline.jsx:17
msgid "More from <0/>"
msgstr "More from <0/>"

#: src/components/columns.jsx:29
#: src/components/nav-menu.jsx:190
#: src/components/shortcuts-settings.jsx:156
#: src/components/timeline.jsx:492
#: src/pages/catchup.jsx:1008
#: src/pages/filters.jsx:90
#: src/pages/followed-hashtags.jsx:41
#: src/pages/home.jsx:54
#: src/pages/notifications.jsx:668
#: src/pages/scheduled-posts.jsx:74
msgid "Home"
msgstr "Home"

#: src/components/compose-button.jsx:150
#: src/compose.jsx:42
msgid "Compose"
msgstr "Compose"

#: src/components/compose-button.jsx:177
#: src/components/nav-menu.jsx:274
#: src/pages/scheduled-posts.jsx:31
#: src/pages/scheduled-posts.jsx:78
msgid "Scheduled Posts"
msgstr "Scheduled Posts"

#: src/components/compose-button.jsx:190
msgid "Add to thread"
msgstr "Add to thread"

#. placeholder {0}: i + 1
#: src/components/compose-poll.jsx:43
msgid "Choice {0}"
msgstr "Choice {0}"

#: src/components/compose-poll.jsx:64
#: src/components/media-attachment.jsx:349
#: src/components/shortcuts-settings.jsx:833
#: src/pages/catchup.jsx:1209
#: src/pages/filters.jsx:415
msgid "Remove"
msgstr "Remove"

#: src/components/compose-poll.jsx:80
#: src/components/compose.jsx:1737
#: src/components/mention-modal.jsx:221
#: src/components/shortcuts-settings.jsx:822
#: src/pages/list.jsx:388
msgid "Add"
msgstr "Add"

#: src/components/compose-poll.jsx:96
msgid "Multiple choice"
msgstr "Multiple choice"

#: src/components/compose-poll.jsx:99
msgid "Duration"
msgstr "Duration"

#: src/components/compose-poll.jsx:129
msgid "Remove poll"
msgstr "Remove poll"

#: src/components/compose.jsx:122
msgid "Take photo or video"
msgstr "Take photo or video"

#: src/components/compose.jsx:123
msgid "Add media"
msgstr "Add media"

#: src/components/compose.jsx:124
msgid "Add custom emoji"
msgstr "Add custom emoji"

#: src/components/compose.jsx:125
msgid "Add GIF"
msgstr "Add GIF"

#: src/components/compose.jsx:126
msgid "Add poll"
msgstr "Add poll"

#: src/components/compose.jsx:127
msgid "Add content warning"
msgstr "Add content warning"

#: src/components/compose.jsx:128
msgid "Schedule post"
msgstr "Schedule post"

#. placeholder {0}: unsupportedFiles.length
#. placeholder {1}: unsupportedFiles[0].name
#. placeholder {2}: lf.format( unsupportedFiles.map((f) => f.name), )
#: src/components/compose.jsx:276
msgid "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"
msgstr "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"

#: src/components/compose.jsx:292
#: src/components/compose.jsx:2160
#: src/components/file-picker-input.jsx:38
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"

#: src/components/compose.jsx:642
msgid "You have unsaved changes. Discard this post?"
msgstr "You have unsaved changes. Discard this post?"

#: src/components/compose.jsx:1093
msgid "Pop out"
msgstr "Pop out"

#: src/components/compose.jsx:1101
msgid "Minimize"
msgstr "Minimize"

#: src/components/compose.jsx:1137
msgid "Looks like you closed the parent window."
msgstr "Looks like you closed the parent window."

#: src/components/compose.jsx:1144
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."

#: src/components/compose.jsx:1149
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"

#: src/components/compose.jsx:1195
msgid "Pop in"
msgstr "Pop in"

#. placeholder {0}: replyToStatus.account.acct || replyToStatus.account.username
#. placeholder {1}: rtf.format(-replyToStatusMonthsAgo, 'month')
#: src/components/compose.jsx:1205
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "Replying to @{0}’s post (<0>{1}</0>)"

#. placeholder {0}: replyToStatus.account.acct || replyToStatus.account.username
#: src/components/compose.jsx:1215
msgid "Replying to @{0}’s post"
msgstr "Replying to @{0}’s post"

#: src/components/compose.jsx:1228
msgid "Editing source post"
msgstr "Editing source post"

#: src/components/compose.jsx:1297
msgid "Poll must have at least 2 options"
msgstr "Poll must have at least 2 options"

#: src/components/compose.jsx:1301
msgid "Some poll choices are empty"
msgstr "Some poll choices are empty"

#: src/components/compose.jsx:1314
msgid "Some media have no descriptions. Continue?"
msgstr "Some media have no descriptions. Continue?"

#: src/components/compose.jsx:1366
msgid "Attachment #{i} failed"
msgstr "Attachment #{i} failed"

#: src/components/compose.jsx:1493
#: src/components/status.jsx:2495
#: src/components/timeline.jsx:1018
msgid "Content warning"
msgstr "Content warning"

#: src/components/compose.jsx:1525
#: src/components/compose.jsx:1671
#: src/components/edit-profile-sheet.jsx:326
#: src/components/import-accounts-selection.jsx:175
#: src/components/open-link-sheet.jsx:74
#: src/components/private-note-sheet.jsx:92
#: src/components/quote-suggestion.jsx:35
msgid "Cancel"
msgstr "Cancel"

#: src/components/compose.jsx:1533
msgid "Post your reply"
msgstr "Post your reply"

#: src/components/compose.jsx:1535
msgid "Edit your post"
msgstr "Edit your post"

#: src/components/compose.jsx:1537
msgid "Ask a question"
msgstr "Ask a question"

#: src/components/compose.jsx:1538
msgid "What are you doing?"
msgstr "What are you doing?"

#: src/components/compose.jsx:1611
msgid "Mark media as sensitive"
msgstr "Mark media as sensitive"

#: src/components/compose.jsx:1651
msgid "Posting on <0/>"
msgstr "Posting on <0/>"

#: src/components/compose.jsx:1949
#: src/components/quote-settings-sheet.jsx:82
#: src/components/status.jsx:296
#: src/pages/settings.jsx:338
msgid "Anyone can quote"
msgstr "Anyone can quote"

#: src/components/compose.jsx:1952
#: src/components/quote-settings-sheet.jsx:85
#: src/components/status.jsx:297
#: src/pages/settings.jsx:341
msgid "Your followers can quote"
msgstr "Your followers can quote"

#: src/components/compose.jsx:1955
#: src/components/quote-settings-sheet.jsx:88
#: src/components/status.jsx:298
#: src/pages/settings.jsx:344
msgid "Only you can quote"
msgstr "Only you can quote"

#: src/components/compose.jsx:1995
msgid "Quotes can't be embedded in private mentions."
msgstr "Quotes can't be embedded in private mentions."

#: src/components/compose.jsx:2017
#: src/pages/settings.jsx:290
#: src/utils/visibility-text.jsx:4
msgid "Public"
msgstr "Public"

#: src/components/compose.jsx:2022
#: src/components/nav-menu.jsx:358
#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:184
#: src/components/shortcuts-settings.jsx:761
#: src/utils/visibility-text.jsx:5
msgid "Local"
msgstr "Local"

#: src/components/compose.jsx:2026
#: src/pages/settings.jsx:293
#: src/utils/visibility-text.jsx:6
msgid "Quiet public"
msgstr "Quiet public"

#: src/components/compose.jsx:2032
#: src/components/status.jsx:2372
#: src/utils/visibility-text.jsx:8
msgid "Private mention"
msgstr "Private mention"

#: src/components/compose.jsx:2084
msgid "Schedule"
msgstr "Schedule"

#: src/components/compose.jsx:2086
#: src/components/keyboard-shortcuts-help.jsx:165
#: src/components/status.jsx:1099
#: src/components/status.jsx:1133
#: src/components/status.jsx:2126
#: src/components/status.jsx:2127
#: src/components/status.jsx:2865
#: src/components/status.jsx:2877
msgid "Reply"
msgstr "Reply"

#: src/components/compose.jsx:2088
msgid "Update"
msgstr "Update"

#: src/components/compose.jsx:2089
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Post"

#: src/components/compose.jsx:2172
msgid "Downloading GIF…"
msgstr "Downloading GIF…"

#: src/components/compose.jsx:2200
msgid "Failed to download GIF"
msgstr "Failed to download GIF"

#. placeholder {0}: i18n.number(emojis.length - max)
#: src/components/custom-emojis-modal.jsx:103
msgid "{0} more…"
msgstr "{0} more…"

#: src/components/custom-emojis-modal.jsx:278
msgid "Custom emojis"
msgstr "Custom emojis"

#: src/components/custom-emojis-modal.jsx:299
msgid "Search emoji"
msgstr "Search emoji"

#: src/components/custom-emojis-modal.jsx:334
msgid "Error loading custom emojis"
msgstr "Error loading custom emojis"

#: src/components/custom-emojis-modal.jsx:345
msgid "Recently used"
msgstr "Recently used"

#: src/components/custom-emojis-modal.jsx:346
msgid "Others"
msgstr "Others"

#: src/components/custom-emojis-modal.jsx:365
msgid "Zoom out"
msgstr "Zoom out"

#: src/components/custom-emojis-modal.jsx:373
msgid "Zoom in"
msgstr "Zoom in"

#: src/components/custom-emojis-modal.jsx:380
msgid "Custom emojis are not available on this server."
msgstr "Custom emojis are not available on this server."

#: src/components/drafts.jsx:62
#: src/pages/settings.jsx:698
msgid "Unsent drafts"
msgstr "Unsent drafts"

#: src/components/drafts.jsx:67
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Looks like you have unsent drafts. Let's continue where you left off."

#: src/components/drafts.jsx:101
msgid "Delete this draft?"
msgstr "Delete this draft?"

#: src/components/drafts.jsx:116
msgid "Error deleting draft! Please try again."
msgstr "Error deleting draft! Please try again."

#: src/components/drafts.jsx:126
#: src/components/list-add-edit.jsx:188
#: src/components/status.jsx:1653
#: src/pages/filters.jsx:605
#: src/pages/scheduled-posts.jsx:398
msgid "Delete…"
msgstr "Delete…"

#: src/components/drafts.jsx:147
msgid "Error fetching reply-to status!"
msgstr "Error fetching reply-to status!"

#: src/components/drafts.jsx:159
msgid "Error fetching quoted status!"
msgstr "Error fetching quoted status!"

#: src/components/drafts.jsx:187
msgid "Delete all drafts?"
msgstr "Delete all drafts?"

#: src/components/drafts.jsx:205
msgid "Error deleting drafts! Please try again."
msgstr "Error deleting drafts! Please try again."

#: src/components/drafts.jsx:217
msgid "Delete all…"
msgstr "Delete all…"

#: src/components/drafts.jsx:225
msgid "No drafts found."
msgstr "No drafts found."

#: src/components/drafts.jsx:263
#: src/pages/catchup.jsx:2089
msgid "Poll"
msgstr "Poll"

#: src/components/drafts.jsx:266
#: src/pages/account-statuses.jsx:440
msgid "Media"
msgstr "Media"

#: src/components/drafts.jsx:270
#: src/components/keyboard-shortcuts-help.jsx:194
#: src/components/status.jsx:762
msgid "Quote"
msgstr "Quote"

#: src/components/edit-history-controls.jsx:21
msgid "Edit History Snapshots"
msgstr "Edit History Snapshots"

#: src/components/edit-history-controls.jsx:35
#: src/components/gif-picker-modal.jsx:208
#: src/components/media-modal.jsx:478
#: src/components/timeline.jsx:931
msgid "Previous"
msgstr "Previous"

#: src/components/edit-history-controls.jsx:47
#: src/components/gif-picker-modal.jsx:226
#: src/components/media-modal.jsx:497
#: src/components/timeline.jsx:948
msgid "Next"
msgstr "Next"

#: src/components/edit-history-controls.jsx:57
msgid "Exit"
msgstr "Exit"

#: src/components/edit-profile-sheet.jsx:149
msgid "Unable to update profile."
msgstr "Unable to update profile."

#: src/components/edit-profile-sheet.jsx:156
msgid "Header picture"
msgstr "Header picture"

#: src/components/edit-profile-sheet.jsx:208
msgid "Profile picture"
msgstr "Profile picture"

#: src/components/edit-profile-sheet.jsx:260
#: src/components/list-add-edit.jsx:106
msgid "Name"
msgstr "Name"

#: src/components/edit-profile-sheet.jsx:274
msgid "Bio"
msgstr "Bio"

#: src/components/edit-profile-sheet.jsx:287
msgid "Extra fields"
msgstr "Extra fields"

#: src/components/edit-profile-sheet.jsx:293
msgid "Label"
msgstr "Label"

#: src/components/edit-profile-sheet.jsx:296
msgid "Content"
msgstr "Content"

#: src/components/edit-profile-sheet.jsx:329
#: src/components/list-add-edit.jsx:152
#: src/components/quote-settings-sheet.jsx:92
#: src/components/shortcuts-settings.jsx:822
#: src/pages/filters.jsx:572
#: src/pages/notifications.jsx:1101
msgid "Save"
msgstr "Save"

#: src/components/embed-modal.jsx:18
msgid "Open in new window"
msgstr "Open in new window"

#. placeholder {0}: info.username
#: src/components/endorsements.jsx:72
msgid "Profiles featured by @{0}"
msgstr "Profiles featured by @{0}"

#: src/components/endorsements.jsx:98
msgid "No featured profiles."
msgstr "No featured profiles."

#: src/components/follow-request-buttons.jsx:43
#: src/pages/notifications.jsx:1085
msgid "Accept"
msgstr "Accept"

#: src/components/follow-request-buttons.jsx:69
msgid "Reject"
msgstr "Reject"

#: src/components/follow-request-buttons.jsx:76
#: src/pages/notifications.jsx:1369
msgid "Accepted"
msgstr "Accepted"

#: src/components/follow-request-buttons.jsx:80
msgid "Rejected"
msgstr "Rejected"

#: src/components/generic-accounts.jsx:154
#: src/components/notification.jsx:481
#: src/pages/accounts.jsx:50
#: src/pages/search.jsx:335
#: src/pages/search.jsx:368
msgid "Accounts"
msgstr "Accounts"

#: src/components/generic-accounts.jsx:214
#: src/components/quotes-modal.jsx:129
#: src/components/timeline.jsx:574
#: src/pages/list.jsx:321
#: src/pages/notifications.jsx:1015
#: src/pages/search.jsx:562
#: src/pages/status.jsx:1685
msgid "Show more…"
msgstr "Show more…"

#: src/components/generic-accounts.jsx:219
#: src/components/quote-chain-modal.jsx:169
#: src/components/quotes-modal.jsx:133
#: src/components/timeline.jsx:579
#: src/pages/search.jsx:567
msgid "The end."
msgstr "The end."

#: src/components/generic-accounts.jsx:236
#: src/components/mention-modal.jsx:234
msgid "Error loading accounts"
msgstr "Error loading accounts"

#: src/components/generic-accounts.jsx:240
msgid "Nothing to show"
msgstr "Nothing to show"

#: src/components/gif-picker-modal.jsx:86
msgid "Search GIFs"
msgstr "Search GIFs"

#: src/components/gif-picker-modal.jsx:102
msgid "Powered by GIPHY"
msgstr "Powered by GIPHY"

#: src/components/gif-picker-modal.jsx:110
msgid "Type to search GIFs"
msgstr "Type to search GIFs"

#: src/components/gif-picker-modal.jsx:243
msgid "Error loading GIFs"
msgstr "Error loading GIFs"

#: src/components/import-accounts-selection.jsx:86
msgid "Select accounts to import"
msgstr "Select accounts to import"

#: src/components/import-accounts-selection.jsx:117
msgid "Select all"
msgstr "Select all"

#: src/components/import-accounts-selection.jsx:158
msgid "Existing"
msgstr "Existing"

#: src/components/import-accounts-selection.jsx:183
msgid "{selectedCount, plural, one {Import # account} other {Import # accounts}}"
msgstr "{selectedCount, plural, one {Import # account} other {Import # accounts}}"

#: src/components/import-export-accounts.jsx:52
msgid "Export failed"
msgstr "Export failed"

#: src/components/import-export-accounts.jsx:72
msgid "Import failed"
msgstr "Import failed"

#: src/components/import-export-accounts.jsx:113
msgid "Import/Export <0>Accounts</0>"
msgstr "Import/Export <0>Accounts</0>"

#: src/components/import-export-accounts.jsx:128
#: src/components/shortcuts-settings.jsx:906
msgid "Import"
msgstr "Import"

#: src/components/import-export-accounts.jsx:139
msgid "Select file…"
msgstr "Select file…"

#: src/components/import-export-accounts.jsx:151
#: src/components/shortcuts-settings.jsx:1154
msgid "Export"
msgstr "Export"

#. placeholder {0}: accounts.length
#: src/components/import-export-accounts.jsx:155
msgid "{0, plural, one {# account} other {# accounts}}"
msgstr "{0, plural, one {# account} other {# accounts}}"

#: src/components/import-export-accounts.jsx:167
msgid "No login information or account access details are stored in the exported files. You will need to log in again for each account after importing."
msgstr "No login information or account access details are stored in the exported files. You will need to log in again for each account after importing."

#: src/components/keyboard-shortcuts-help.jsx:16
msgid "<0>{key1}</0> then <1>{key2}</1>"
msgstr "<0>{key1}</0> then <1>{key2}</1>"

#: src/components/keyboard-shortcuts-help.jsx:57
#: src/components/nav-menu.jsx:386
#: src/pages/catchup.jsx:1750
msgid "Keyboard shortcuts"
msgstr "Keyboard shortcuts"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "Keyboard shortcuts help"
msgstr "Keyboard shortcuts help"

#: src/components/keyboard-shortcuts-help.jsx:69
#: src/pages/catchup.jsx:1775
msgid "Next post"
msgstr "Next post"

#: src/components/keyboard-shortcuts-help.jsx:73
#: src/pages/catchup.jsx:1783
msgid "Previous post"
msgstr "Previous post"

#: src/components/keyboard-shortcuts-help.jsx:77
msgid "Skip carousel to next post"
msgstr "Skip carousel to next post"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Shift</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "Skip carousel to previous post"
msgstr "Skip carousel to previous post"

#: src/components/keyboard-shortcuts-help.jsx:87
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Shift</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:93
msgid "Load new posts"
msgstr "Load new posts"

#: src/components/keyboard-shortcuts-help.jsx:97
#: src/pages/catchup.jsx:1807
msgid "Open post details"
msgstr "Open post details"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Open media or post details"
msgstr "Open media or post details"

#: src/components/keyboard-shortcuts-help.jsx:106
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Expand content warning or<0/>toggle expanded/collapsed thread"

#: src/components/keyboard-shortcuts-help.jsx:115
msgid "Close post or dialogs"
msgstr "Close post or dialogs"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> or <1>Backspace</1>"

#: src/components/keyboard-shortcuts-help.jsx:123
msgid "Focus column in multi-column mode"
msgstr "Focus column in multi-column mode"

#: src/components/keyboard-shortcuts-help.jsx:125
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> to <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:131
msgid "Focus next column in multi-column mode"
msgstr "Focus next column in multi-column mode"

#: src/components/keyboard-shortcuts-help.jsx:135
msgid "Focus previous column in multi-column mode"
msgstr "Focus previous column in multi-column mode"

#: src/components/keyboard-shortcuts-help.jsx:139
msgid "Compose new post"
msgstr "Compose new post"

#: src/components/keyboard-shortcuts-help.jsx:143
msgid "Compose new post (new window)"
msgstr "Compose new post (new window)"

#: src/components/keyboard-shortcuts-help.jsx:146
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Shift</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:152
msgid "Send post"
msgstr "Send post"

#: src/components/keyboard-shortcuts-help.jsx:154
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"

#: src/components/keyboard-shortcuts-help.jsx:161
#: src/components/nav-menu.jsx:346
#: src/components/search-form.jsx:208
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:213
#: src/pages/search.jsx:47
#: src/pages/search.jsx:317
msgid "Search"
msgstr "Search"

#: src/components/keyboard-shortcuts-help.jsx:169
msgid "Reply (new window)"
msgstr "Reply (new window)"

#: src/components/keyboard-shortcuts-help.jsx:172
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Shift</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "Like (favourite)"
msgstr "Like (favourite)"

#: src/components/keyboard-shortcuts-help.jsx:180
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> or <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:186
#: src/components/status.jsx:1169
#: src/components/status.jsx:2908
#: src/components/status.jsx:2974
msgid "Boost"
msgstr "Boost"

#: src/components/keyboard-shortcuts-help.jsx:188
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Shift</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:198
#: src/components/status.jsx:1271
#: src/components/status.jsx:3003
#: src/components/status.jsx:3004
msgid "Bookmark"
msgstr "Bookmark"

#: src/components/keyboard-shortcuts-help.jsx:202
msgid "Toggle Cloak mode"
msgstr "Toggle Cloak mode"

#: src/components/keyboard-shortcuts-help.jsx:204
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Shift</0> + <1>Alt</1> + <2>k</2>"

#: src/components/keyboard-shortcuts-help.jsx:210
msgid "Go to Home"
msgstr "Go to Home"

#: src/components/keyboard-shortcuts-help.jsx:214
msgid "Go to Notifications"
msgstr "Go to Notifications"

#: src/components/keyboard-shortcuts-help.jsx:218
msgid "Go to Settings"
msgstr "Go to Settings"

#: src/components/keyboard-shortcuts-help.jsx:222
msgid "Go to Profile"
msgstr "Go to Profile"

#: src/components/keyboard-shortcuts-help.jsx:226
msgid "Go to Bookmarks"
msgstr "Go to Bookmarks"

#: src/components/list-add-edit.jsx:41
msgid "Edit list"
msgstr "Edit list"

#: src/components/list-add-edit.jsx:97
msgid "Unable to edit list."
msgstr "Unable to edit list."

#: src/components/list-add-edit.jsx:98
msgid "Unable to create list."
msgstr "Unable to create list."

#: src/components/list-add-edit.jsx:126
msgid "Show replies to list members"
msgstr "Show replies to list members"

#: src/components/list-add-edit.jsx:129
msgid "Show replies to people I follow"
msgstr "Show replies to people I follow"

#: src/components/list-add-edit.jsx:132
msgid "Don't show replies"
msgstr "Don't show replies"

#: src/components/list-add-edit.jsx:146
msgid "Hide posts on this list from Home/Following"
msgstr "Hide posts on this list from Home/Following"

#: src/components/list-add-edit.jsx:152
#: src/pages/filters.jsx:572
msgid "Create"
msgstr "Create"

#: src/components/list-add-edit.jsx:159
msgid "Delete this list?"
msgstr "Delete this list?"

#: src/components/list-add-edit.jsx:178
msgid "Unable to delete list."
msgstr "Unable to delete list."

#: src/components/list-exclusive-badge.jsx:14
#: src/pages/list.jsx:179
#: src/pages/lists.jsx:107
msgid "Posts on this list are hidden from Home/Following"
msgstr "Posts on this list are hidden from Home/Following"

#: src/components/math-block.jsx:132
msgid "Unable to format math"
msgstr "Unable to format math"

#: src/components/math-block.jsx:146
msgid "Math expressions found."
msgstr "Math expressions found."

#. Action to switch from rendered math back to raw (LaTeX) markup
#: src/components/math-block.jsx:149
msgid "Show markup"
msgstr "Show markup"

#. Action to render math expressions from raw (LaTeX) markup
#: src/components/math-block.jsx:154
msgid "Format math"
msgstr "Format math"

#: src/components/media-alt-modal.jsx:48
#: src/components/media.jsx:51
msgid "Media description"
msgstr "Media description"

#: src/components/media-alt-modal.jsx:55
#: src/components/media-attachment.jsx:430
#: src/components/media-modal.jsx:372
#: src/components/related-actions.jsx:273
#: src/components/status.jsx:2150
#: src/components/status.jsx:2167
#: src/components/status.jsx:2299
#: src/components/status.jsx:3024
#: src/components/status.jsx:3027
#: src/pages/account-statuses.jsx:641
#: src/pages/accounts.jsx:147
#: src/pages/hashtag.jsx:232
#: src/pages/list.jsx:171
#: src/pages/public.jsx:169
#: src/pages/scheduled-posts.jsx:89
#: src/pages/status.jsx:1552
#: src/pages/trending.jsx:474
msgid "More"
msgstr "More"

#: src/components/media-alt-modal.jsx:67
#: src/components/status.jsx:1338
#: src/components/status.jsx:1347
#: src/components/translation-block.jsx:270
msgid "Translate"
msgstr "Translate"

#: src/components/media-alt-modal.jsx:78
#: src/components/status.jsx:1368
msgid "Speak"
msgstr "Speak"

#: src/components/media-attachment.jsx:198
msgid "Uploaded"
msgstr "Uploaded"

#: src/components/media-attachment.jsx:211
msgid "Image description"
msgstr "Image description"

#: src/components/media-attachment.jsx:212
#: src/components/media-attachment.jsx:213
msgid "Video description"
msgstr "Video description"

#: src/components/media-attachment.jsx:214
msgid "Audio description"
msgstr "Audio description"

#. placeholder {0}: prettyBytes( imageSize, )
#. placeholder {0}: prettyBytes( videoSize, )
#. placeholder {1}: prettyBytes(imageSizeLimit)
#. placeholder {1}: prettyBytes(videoSizeLimit)
#: src/components/media-attachment.jsx:249
#: src/components/media-attachment.jsx:269
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."

#. placeholder {0}: i18n.number( width, )
#. placeholder {1}: i18n.number(height)
#. placeholder {2}: i18n.number(newWidth)
#. placeholder {3}: i18n.number( newHeight, )
#: src/components/media-attachment.jsx:261
#: src/components/media-attachment.jsx:281
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."

#: src/components/media-attachment.jsx:289
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Frame rate too high. Uploading might encounter issues."

#: src/components/media-attachment.jsx:366
#: src/compose.jsx:88
msgid "Error"
msgstr "Error"

#: src/components/media-attachment.jsx:391
msgid "Edit image description"
msgstr "Edit image description"

#: src/components/media-attachment.jsx:392
#: src/components/media-attachment.jsx:393
msgid "Edit video description"
msgstr "Edit video description"

#: src/components/media-attachment.jsx:394
msgid "Edit audio description"
msgstr "Edit audio description"

#: src/components/media-attachment.jsx:439
#: src/components/media-attachment.jsx:488
msgid "Generating description. Please wait…"
msgstr "Generating description. Please wait…"

#. placeholder {0}: e.message
#: src/components/media-attachment.jsx:459
msgid "Failed to generate description: {0}"
msgstr "Failed to generate description: {0}"

#: src/components/media-attachment.jsx:460
msgid "Failed to generate description"
msgstr "Failed to generate description"

#: src/components/media-attachment.jsx:472
#: src/components/media-attachment.jsx:478
#: src/components/media-attachment.jsx:524
msgid "Generate description…"
msgstr "Generate description…"

#. placeholder {0}: e?.message ? `: ${e.message}` : ''
#: src/components/media-attachment.jsx:511
msgid "Failed to generate description{0}"
msgstr "Failed to generate description{0}"

#. placeholder {0}: localeCode2Text(lang)
#: src/components/media-attachment.jsx:526
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— experimental</0>"

#: src/components/media-attachment.jsx:545
msgid "Done"
msgstr "Done"

#: src/components/media-modal.jsx:383
msgid "Open original media in new window"
msgstr "Open original media in new window"

#: src/components/media-modal.jsx:387
msgid "Open original media"
msgstr "Open original media"

#: src/components/media-modal.jsx:403
msgid "Attempting to describe image. Please wait…"
msgstr "Attempting to describe image. Please wait…"

#: src/components/media-modal.jsx:418
msgid "Failed to describe image"
msgstr "Failed to describe image"

#: src/components/media-modal.jsx:428
msgid "Describe image…"
msgstr "Describe image…"

#: src/components/media-modal.jsx:452
msgid "View post"
msgstr "View post"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "Sensitive media"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "Filtered: {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status-compact.jsx:70
#: src/components/status.jsx:3529
#: src/components/status.jsx:3607
#: src/components/timeline.jsx:1007
#: src/pages/catchup.jsx:79
#: src/pages/catchup.jsx:2033
msgid "Filtered"
msgstr "Filtered"

#: src/components/media.jsx:486
msgid "Open file"
msgstr "Open file"

#: src/components/mention-modal.jsx:179
msgid "Search accounts"
msgstr "Search accounts"

#: src/components/modals.jsx:93
msgid "Post scheduled"
msgstr "Post scheduled"

#: src/components/modals.jsx:94
msgid "Post published. Check it out."
msgstr "Post published. Check it out."

#: src/components/modals.jsx:96
msgid "Reply scheduled"
msgstr "Reply scheduled"

#: src/components/modals.jsx:97
msgid "Reply posted. Check it out."
msgstr "Reply posted. Check it out."

#: src/components/modals.jsx:98
msgid "Post updated. Check it out."
msgstr "Post updated. Check it out."

#: src/components/nav-menu.jsx:132
msgid "Menu"
msgstr "Menu"

#: src/components/nav-menu.jsx:168
msgid "Reload page now to update?"
msgstr "Reload page now to update?"

#: src/components/nav-menu.jsx:180
msgid "New update available…"
msgstr "New update available…"

#. js-lingui-explicit-id
#: src/components/nav-menu.jsx:199
#: src/components/shortcuts-settings.jsx:157
#: src/pages/following.jsx:23
#: src/pages/following.jsx:156
msgid "following.title"
msgstr "Following"

#: src/components/nav-menu.jsx:206
#: src/pages/catchup.jsx:1003
#: src/pages/welcome.jsx:154
msgid "Catch-up"
msgstr "Catch-up"

#: src/components/nav-menu.jsx:213
#: src/components/shortcuts-settings.jsx:60
#: src/components/shortcuts-settings.jsx:163
#: src/pages/home.jsx:240
#: src/pages/mentions.jsx:25
#: src/pages/mentions.jsx:256
#: src/pages/notifications.jsx:892
#: src/pages/settings.jsx:1261
#: src/pages/trending.jsx:384
msgid "Mentions"
msgstr "Mentions"

#: src/components/nav-menu.jsx:220
#: src/components/shortcuts-settings.jsx:51
#: src/components/shortcuts-settings.jsx:169
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:86
#: src/pages/home.jsx:198
#: src/pages/notifications.jsx:111
#: src/pages/notifications.jsx:672
msgid "Notifications"
msgstr "Notifications"

#: src/components/nav-menu.jsx:223
msgid "New"
msgstr "New"

#: src/components/nav-menu.jsx:234
#: src/components/shortcuts-settings.jsx:61
#: src/components/shortcuts-settings.jsx:223
msgid "Profile"
msgstr "Profile"

#: src/components/nav-menu.jsx:242
#: src/components/shortcuts-settings.jsx:56
#: src/components/shortcuts-settings.jsx:243
#: src/pages/bookmarks.jsx:12
#: src/pages/bookmarks.jsx:26
msgid "Bookmarks"
msgstr "Bookmarks"

#: src/components/nav-menu.jsx:253
#: src/components/text-expander.jsx:215
msgid "More…"
msgstr "More…"

#: src/components/nav-menu.jsx:262
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:249
#: src/pages/catchup.jsx:1576
#: src/pages/catchup.jsx:2236
#: src/pages/favourites.jsx:12
#: src/pages/favourites.jsx:26
#: src/pages/settings.jsx:1265
msgid "Likes"
msgstr "Likes"

#: src/components/nav-menu.jsx:268
#: src/pages/followed-hashtags.jsx:15
#: src/pages/followed-hashtags.jsx:45
msgid "Followed Hashtags"
msgstr "Followed Hashtags"

#: src/components/nav-menu.jsx:282
#: src/pages/account-statuses.jsx:382
#: src/pages/filters.jsx:55
#: src/pages/filters.jsx:94
#: src/pages/hashtag.jsx:373
msgid "Filters"
msgstr "Filters"

#: src/components/nav-menu.jsx:290
msgid "Muted users"
msgstr "Muted users"

#: src/components/nav-menu.jsx:298
msgid "Muted users…"
msgstr "Muted users…"

#: src/components/nav-menu.jsx:305
msgid "Blocked users"
msgstr "Blocked users"

#: src/components/nav-menu.jsx:313
msgid "Blocked users…"
msgstr "Blocked users…"

#: src/components/nav-menu.jsx:325
msgid "Accounts…"
msgstr "Accounts…"

#: src/components/nav-menu.jsx:335
#: src/pages/login.jsx:33
#: src/pages/login.jsx:227
#: src/pages/status.jsx:1081
#: src/pages/welcome.jsx:63
msgid "Log in"
msgstr "Log in"

#: src/components/nav-menu.jsx:352
#: src/components/shortcuts-settings.jsx:59
#: src/components/shortcuts-settings.jsx:206
#: src/pages/trending.jsx:444
msgid "Trending"
msgstr "Trending"

#: src/components/nav-menu.jsx:366
#: src/components/shortcuts-settings.jsx:82
#: src/components/shortcuts-settings.jsx:185
#: src/components/shortcuts-settings.jsx:764
msgid "Bubble"
msgstr "Bubble"

#: src/components/nav-menu.jsx:373
#: src/components/shortcuts-settings.jsx:86
#: src/components/shortcuts-settings.jsx:186
#: src/components/shortcuts-settings.jsx:767
msgid "Federated"
msgstr "Federated"

#: src/components/nav-menu.jsx:396
msgid "Shortcuts / Columns…"
msgstr "Shortcuts / Columns…"

#: src/components/nav-menu.jsx:406
#: src/components/nav-menu.jsx:420
msgid "Settings…"
msgstr "Settings…"

#: src/components/nav-menu.jsx:450
#: src/components/nav-menu.jsx:485
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:175
#: src/pages/list.jsx:127
#: src/pages/lists.jsx:18
#: src/pages/lists.jsx:54
msgid "Lists"
msgstr "Lists"

#: src/components/nav-menu.jsx:458
#: src/components/shortcuts.jsx:32
#: src/pages/list.jsx:139
msgid "All Lists"
msgstr "All Lists"

#: src/components/notification-service.jsx:161
msgid "Notification"
msgstr "Notification"

#: src/components/notification-service.jsx:167
msgid "This notification is from your other account."
msgstr "This notification is from your other account."

#: src/components/notification-service.jsx:196
msgid "View all notifications"
msgstr "View all notifications"

#: src/components/notification.jsx:75
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} reacted to your post with {emojiObject}"

#: src/components/notification.jsx:82
msgid "{account} published a post."
msgstr "{account} published a post."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:90
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"

#. placeholder {0}: shortenNumber(count)
#: src/components/notification.jsx:133
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"

#: src/components/notification.jsx:147
msgid "{account} requested to follow you."
msgstr "{account} requested to follow you."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:156
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"

#: src/components/notification.jsx:198
msgid "A poll you have voted in or created has ended."
msgstr "A poll you have voted in or created has ended."

#: src/components/notification.jsx:199
msgid "A poll you have created has ended."
msgstr "A poll you have created has ended."

#: src/components/notification.jsx:200
msgid "A poll you have voted in has ended."
msgstr "A poll you have voted in has ended."

#: src/components/notification.jsx:203
msgid "{account} edited a post."
msgstr "{account} edited a post."

#: src/components/notification.jsx:205
msgid "A post you interacted with has been edited."
msgstr "A post you interacted with has been edited."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:214
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"

#: src/components/notification.jsx:257
msgid "{account} edited a post you have quoted."
msgstr "{account} edited a post you have quoted."

#. placeholder {0}: shortenNumber(count)
#: src/components/notification.jsx:260
msgid "{count, plural, =1 {{account} signed up.} other {<0><1>{0}</1> people</0> signed up.}}"
msgstr "{count, plural, =1 {{account} signed up.} other {<0><1>{0}</1> people</0> signed up.}}"

#: src/components/notification.jsx:274
msgid "{account} reported {targetAccount}"
msgstr "{account} reported {targetAccount}"

#: src/components/notification.jsx:279
msgid "Lost connections with <0>{name}</0>."
msgstr "Lost connections with <0>{name}</0>."

#: src/components/notification.jsx:285
msgid "Moderation warning"
msgstr "Moderation warning"

#: src/components/notification.jsx:290
msgid "Your {year} #Wrapstodon is here!"
msgstr "Your {year} #Wrapstodon is here!"

#: src/components/notification.jsx:296
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."

#: src/components/notification.jsx:302
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."

#: src/components/notification.jsx:308
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."

#: src/components/notification.jsx:316
msgid "Your account has received a moderation warning."
msgstr "Your account has received a moderation warning."

#: src/components/notification.jsx:317
msgid "Your account has been disabled."
msgstr "Your account has been disabled."

#: src/components/notification.jsx:318
msgid "Some of your posts have been marked as sensitive."
msgstr "Some of your posts have been marked as sensitive."

#: src/components/notification.jsx:319
msgid "Some of your posts have been deleted."
msgstr "Some of your posts have been deleted."

#: src/components/notification.jsx:320
msgid "Your posts will be marked as sensitive from now on."
msgstr "Your posts will be marked as sensitive from now on."

#: src/components/notification.jsx:321
msgid "Your account has been limited."
msgstr "Your account has been limited."

#: src/components/notification.jsx:322
msgid "Your account has been suspended."
msgstr "Your account has been suspended."

#: src/components/notification.jsx:399
msgid "[Unknown notification type: {type}]"
msgstr "[Unknown notification type: {type}]"

#: src/components/notification.jsx:477
#: src/components/status.jsx:1285
#: src/components/status.jsx:1295
msgid "Boosted/Liked by…"
msgstr "Boosted/Liked by…"

#: src/components/notification.jsx:478
msgid "Liked by…"
msgstr "Liked by…"

#: src/components/notification.jsx:479
msgid "Boosted by…"
msgstr "Boosted by…"

#: src/components/notification.jsx:480
msgid "Followed by…"
msgstr "Followed by…"

#: src/components/notification.jsx:624
#: src/components/notification.jsx:640
msgid "Learn more <0/>"
msgstr "Learn more <0/>"

#: src/components/notification.jsx:649
msgid "View #Wrapstodon"
msgstr "View #Wrapstodon"

#: src/components/notification.jsx:847
#: src/components/quote-chain-modal.jsx:18
#: src/components/status.jsx:259
msgid "Read more →"
msgstr "Read more →"

#: src/components/open-link-sheet.jsx:30
#: src/components/related-actions.jsx:556
#: src/components/status.jsx:1459
msgid "Link copied"
msgstr "Link copied"

#: src/components/open-link-sheet.jsx:33
#: src/components/related-actions.jsx:559
#: src/components/status.jsx:1462
msgid "Unable to copy link"
msgstr "Unable to copy link"

#: src/components/open-link-sheet.jsx:56
msgid "Open link?"
msgstr "Open link?"

#: src/components/open-link-sheet.jsx:78
#: src/components/post-embed-modal.jsx:232
#: src/components/related-actions.jsx:565
#: src/components/shortcuts-settings.jsx:1263
#: src/components/status.jsx:1468
msgid "Copy"
msgstr "Copy"

#: src/components/open-link-sheet.jsx:82
#: src/components/related-actions.jsx:586
#: src/components/status.jsx:1490
msgid "Share…"
msgstr "Share…"

#: src/components/open-link-sheet.jsx:92
msgid "Open"
msgstr "Open"

#: src/components/poll.jsx:159
msgid "{optionVotesCount, plural, one {# vote} other {# votes}}"
msgstr "{optionVotesCount, plural, one {# vote} other {# votes}}"

#: src/components/poll.jsx:166
msgid "Voted"
msgstr "Voted"

#: src/components/poll.jsx:190
#: src/components/poll.jsx:387
#: src/components/poll.jsx:391
msgid "Hide results"
msgstr "Hide results"

#. placeholder {0}: options.length
#: src/components/poll.jsx:195
#: src/components/poll.jsx:288
#: src/components/poll.jsx:304
msgid "{0, plural, one {# choice} other {# choices}}"
msgstr "{0, plural, one {# choice} other {# choices}}"

#: src/components/poll.jsx:221
msgid "Unable to vote in poll"
msgstr "Unable to vote in poll"

#: src/components/poll.jsx:277
msgid "Vote"
msgstr "Vote"

#. placeholder {0}: shortenNumber(votesCount)
#. placeholder {1}: shortenNumber(votesCount)
#: src/components/poll.jsx:314
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"

#. placeholder {0}: shortenNumber(votersCount)
#. placeholder {1}: shortenNumber(votersCount)
#: src/components/poll.jsx:335
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"

#: src/components/poll.jsx:361
msgid "Ended <0/>"
msgstr "Ended <0/>"

#: src/components/poll.jsx:366
msgid "Ended"
msgstr "Ended"

#: src/components/poll.jsx:370
msgid "Ending <0/>"
msgstr "Ending <0/>"

#: src/components/poll.jsx:375
msgid "Ending"
msgstr "Ending"

#: src/components/poll.jsx:387
#: src/components/poll.jsx:391
msgid "Show results"
msgstr "Show results"

#: src/components/poll.jsx:409
#: src/components/poll.jsx:411
#: src/pages/scheduled-posts.jsx:100
#: src/pages/status.jsx:1541
#: src/pages/status.jsx:1564
msgid "Refresh"
msgstr "Refresh"

#: src/components/post-embed-modal.jsx:201
#: src/components/status.jsx:1503
msgid "Embed post"
msgstr "Embed post"

#: src/components/post-embed-modal.jsx:206
msgid "HTML Code"
msgstr "HTML Code"

#: src/components/post-embed-modal.jsx:223
msgid "HTML code copied"
msgstr "HTML code copied"

#: src/components/post-embed-modal.jsx:226
msgid "Unable to copy HTML code"
msgstr "Unable to copy HTML code"

#: src/components/post-embed-modal.jsx:238
msgid "Media attachments:"
msgstr "Media attachments:"

#: src/components/post-embed-modal.jsx:260
msgid "Account Emojis:"
msgstr "Account Emojis:"

#: src/components/post-embed-modal.jsx:291
#: src/components/post-embed-modal.jsx:336
msgid "static URL"
msgstr "static URL"

#: src/components/post-embed-modal.jsx:305
msgid "Emojis:"
msgstr "Emojis:"

#: src/components/post-embed-modal.jsx:350
msgid "Notes:"
msgstr "Notes:"

#: src/components/post-embed-modal.jsx:354
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."

#: src/components/post-embed-modal.jsx:360
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "Polls are not interactive, becomes a list with vote counts."

#: src/components/post-embed-modal.jsx:365
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Media attachments can be images, videos, audios or any file types."

#: src/components/post-embed-modal.jsx:371
msgid "Post could be edited or deleted later."
msgstr "Post could be edited or deleted later."

#: src/components/post-embed-modal.jsx:377
msgid "Preview"
msgstr "Preview"

#: src/components/post-embed-modal.jsx:386
msgid "Note: This preview is lightly styled."
msgstr "Note: This preview is lightly styled."

#: src/components/private-note-sheet.jsx:41
#: src/components/related-actions.jsx:232
msgid "Notes"
msgstr "Notes"

#: src/components/private-note-sheet.jsx:44
msgid "Only visible to you"
msgstr "Only visible to you"

#: src/components/private-note-sheet.jsx:69
msgid "Unable to update private note."
msgstr "Unable to update private note."

#: src/components/private-note-sheet.jsx:97
msgid "Save & close"
msgstr "Save & close"

#: src/components/qr-code-modal.jsx:26
#: src/components/shortcuts-settings.jsx:939
msgid "Scan QR code"
msgstr "Scan QR code"

#: src/components/qr-scanner-modal.jsx:263
msgid "Unable to access camera. Please check permissions."
msgstr "Unable to access camera. Please check permissions."

#: src/components/quote-chain-modal.jsx:107
msgid "Quote chain"
msgstr "Quote chain"

#: src/components/quote-chain-modal.jsx:151
msgid "Failed to unwrap quote chain"
msgstr "Failed to unwrap quote chain"

#: src/components/quote-chain-modal.jsx:165
msgid "Continue unwrapping…"
msgstr "Continue unwrapping…"

#: src/components/quote-settings-sheet.jsx:37
#: src/pages/settings.jsx:329
msgid "Quote settings updated"
msgstr "Quote settings updated"

#: src/components/quote-settings-sheet.jsx:47
#: src/pages/settings.jsx:331
msgid "Failed to update quote settings"
msgstr "Failed to update quote settings"

#: src/components/quote-settings-sheet.jsx:66
msgid "Quote settings for this post"
msgstr "Quote settings for this post"

#: src/components/quote-suggestion.jsx:19
msgid "Turn link into a quote?"
msgstr "Turn link into a quote?"

#: src/components/quote-suggestion.jsx:37
msgid "Keep as link"
msgstr "Keep as link"

#: src/components/quote-suggestion.jsx:42
msgid "Replace current quote"
msgstr "Replace current quote"

#: src/components/quote-suggestion.jsx:44
msgid "Turn into quote"
msgstr "Turn into quote"

#: src/components/quotes-modal.jsx:150
msgid "Error loading quotes"
msgstr "Error loading quotes"

#: src/components/quotes-modal.jsx:154
msgid "No quotes yet"
msgstr "No quotes yet"

#: src/components/recent-searches.jsx:27
msgid "Cleared recent searches"
msgstr "Cleared recent searches"

#: src/components/recent-searches.jsx:49
#: src/components/search-form.jsx:333
msgid "Recent searches"
msgstr "Recent searches"

#: src/components/recent-searches.jsx:59
msgid "Clear all"
msgstr "Clear all"

#: src/components/recent-searches.jsx:94
#: src/pages/account-statuses.jsx:375
msgid "Clear"
msgstr "Clear"

#: src/components/related-actions.jsx:40
msgid "Forever"
msgstr "Forever"

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/related-actions.jsx:204
msgid "Last post: <0>{0}</0>"
msgstr "Last post: <0>{0}</0>"

#: src/components/related-actions.jsx:218
msgid "Muted"
msgstr "Muted"

#: src/components/related-actions.jsx:223
msgid "Blocked"
msgstr "Blocked"

#: src/components/related-actions.jsx:306
msgid "Mention <0>@{username}</0>"
msgstr "Mention <0>@{username}</0>"

#: src/components/related-actions.jsx:319
msgid "Search <0>@{username}</0>'s posts"
msgstr "Search <0>@{username}</0>'s posts"

#: src/components/related-actions.jsx:333
msgid "Translate bio"
msgstr "Translate bio"

#: src/components/related-actions.jsx:343
msgid "Edit notes"
msgstr "Edit notes"

#: src/components/related-actions.jsx:343
msgid "Add notes"
msgstr "Add notes"

#: src/components/related-actions.jsx:362
msgid "Notifications enabled for @{username}'s posts."
msgstr "Notifications enabled for @{username}'s posts."

#: src/components/related-actions.jsx:363
msgid " Notifications disabled for @{username}'s posts."
msgstr " Notifications disabled for @{username}'s posts."

#: src/components/related-actions.jsx:375
msgid "Disable notifications"
msgstr "Disable notifications"

#: src/components/related-actions.jsx:376
msgid "Enable notifications"
msgstr "Enable notifications"

#: src/components/related-actions.jsx:393
msgid "Boosts from @{username} enabled."
msgstr "Boosts from @{username} enabled."

#: src/components/related-actions.jsx:394
msgid "Boosts from @{username} disabled."
msgstr "Boosts from @{username} disabled."

#: src/components/related-actions.jsx:405
msgid "Disable boosts"
msgstr "Disable boosts"

#: src/components/related-actions.jsx:405
msgid "Enable boosts"
msgstr "Enable boosts"

#: src/components/related-actions.jsx:424
msgid "@{username} is no longer featured on your profile."
msgstr "@{username} is no longer featured on your profile."

#: src/components/related-actions.jsx:434
msgid "@{username} is now featured on your profile."
msgstr "@{username} is now featured on your profile."

#: src/components/related-actions.jsx:442
msgid "Unable to unfeature @{username} on your profile."
msgstr "Unable to unfeature @{username} on your profile."

#: src/components/related-actions.jsx:446
msgid "Unable to feature @{username} on your profile."
msgstr "Unable to feature @{username} on your profile."

#: src/components/related-actions.jsx:455
msgid "Don't feature on profile"
msgstr "Don't feature on profile"

#: src/components/related-actions.jsx:456
#: src/pages/hashtag.jsx:362
msgid "Feature on profile"
msgstr "Feature on profile"

#: src/components/related-actions.jsx:465
#: src/components/related-actions.jsx:515
msgid "Show featured profiles"
msgstr "Show featured profiles"

#: src/components/related-actions.jsx:507
#: src/pages/account-statuses.jsx:546
msgid "Search my posts"
msgstr "Search my posts"

#: src/components/related-actions.jsx:580
#: src/components/shortcuts-settings.jsx:1281
#: src/components/status.jsx:1484
msgid "Sharing doesn't seem to work."
msgstr "Sharing doesn't seem to work."

#: src/components/related-actions.jsx:622
msgid "Unmuted @{username}"
msgstr "Unmuted @{username}"

#: src/components/related-actions.jsx:634
msgid "Unmute <0>@{username}</0>"
msgstr "Unmute <0>@{username}</0>"

#: src/components/related-actions.jsx:650
msgid "Mute <0>@{username}</0>…"
msgstr "Mute <0>@{username}</0>…"

#. placeholder {0}: typeof MUTE_DURATIONS_LABELS[duration] === 'function' ? MUTE_DURATIONS_LABELS[duration]() : _(MUTE_DURATIONS_LABELS[duration])
#: src/components/related-actions.jsx:682
msgid "Muted @{username} for {0}"
msgstr "Muted @{username} for {0}"

#: src/components/related-actions.jsx:694
msgid "Unable to mute @{username}"
msgstr "Unable to mute @{username}"

#: src/components/related-actions.jsx:715
msgid "Remove <0>@{username}</0> from followers?"
msgstr "Remove <0>@{username}</0> from followers?"

#: src/components/related-actions.jsx:735
msgid "@{username} removed from followers"
msgstr "@{username} removed from followers"

#: src/components/related-actions.jsx:747
msgid "Remove follower…"
msgstr "Remove follower…"

#: src/components/related-actions.jsx:758
msgid "Block <0>@{username}</0>?"
msgstr "Block <0>@{username}</0>?"

#: src/components/related-actions.jsx:782
msgid "Unblocked @{username}"
msgstr "Unblocked @{username}"

#: src/components/related-actions.jsx:790
msgid "Blocked @{username}"
msgstr "Blocked @{username}"

#: src/components/related-actions.jsx:798
msgid "Unable to unblock @{username}"
msgstr "Unable to unblock @{username}"

#: src/components/related-actions.jsx:800
msgid "Unable to block @{username}"
msgstr "Unable to block @{username}"

#: src/components/related-actions.jsx:810
msgid "Unblock <0>@{username}</0>"
msgstr "Unblock <0>@{username}</0>"

#: src/components/related-actions.jsx:819
msgid "Block <0>@{username}</0>…"
msgstr "Block <0>@{username}</0>…"

#: src/components/related-actions.jsx:836
msgid "Report <0>@{username}</0>…"
msgstr "Report <0>@{username}</0>…"

#: src/components/related-actions.jsx:892
msgid "Withdraw follow request?"
msgstr "Withdraw follow request?"

#. placeholder {0}: info.acct || info.username
#: src/components/related-actions.jsx:893
msgid "Unfollow @{0}?"
msgstr "Unfollow @{0}?"

#: src/components/related-actions.jsx:956
msgid "Unfollow…"
msgstr "Unfollow…"

#: src/components/related-actions.jsx:965
msgid "Withdraw…"
msgstr "Withdraw…"

#: src/components/related-actions.jsx:972
#: src/components/related-actions.jsx:976
#: src/pages/hashtag.jsx:294
msgid "Follow"
msgstr "Follow"

#. Relative time in seconds, as short as possible
#. placeholder {0}: seconds < 1 ? 1 : Math.floor(seconds)
#: src/components/relative-time.jsx:45
msgid "{0}s"
msgstr "{0}s"

#. Relative time in minutes, as short as possible
#. placeholder {0}: Math.floor(seconds / minute)
#: src/components/relative-time.jsx:50
msgid "{0}m"
msgstr "{0}m"

#. Relative time in hours, as short as possible
#. placeholder {0}: Math.floor(seconds / hour)
#: src/components/relative-time.jsx:55
msgid "{0}h"
msgstr "{0}h"

#: src/components/report-modal.jsx:30
msgid "Spam"
msgstr "Spam"

#: src/components/report-modal.jsx:31
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Malicious links, fake engagement, or repetitive replies"

#: src/components/report-modal.jsx:34
msgid "Illegal"
msgstr "Illegal"

#: src/components/report-modal.jsx:35
msgid "Violates the law of your or the server's country"
msgstr "Violates the law of your or the server's country"

#: src/components/report-modal.jsx:38
msgid "Server rule violation"
msgstr "Server rule violation"

#: src/components/report-modal.jsx:39
msgid "Breaks specific server rules"
msgstr "Breaks specific server rules"

#: src/components/report-modal.jsx:40
msgid "Violation"
msgstr "Violation"

#: src/components/report-modal.jsx:43
msgid "Other"
msgstr "Other"

#: src/components/report-modal.jsx:44
msgid "Issue doesn't fit other categories"
msgstr "Issue doesn't fit other categories"

#: src/components/report-modal.jsx:111
msgid "Report Post"
msgstr "Report Post"

#: src/components/report-modal.jsx:111
msgid "Report @{username}"
msgstr "Report @{username}"

#: src/components/report-modal.jsx:147
msgid "Pending review"
msgstr "Pending review"

#: src/components/report-modal.jsx:189
msgid "Post reported"
msgstr "Post reported"

#: src/components/report-modal.jsx:189
msgid "Profile reported"
msgstr "Profile reported"

#: src/components/report-modal.jsx:197
msgid "Unable to report post"
msgstr "Unable to report post"

#: src/components/report-modal.jsx:198
msgid "Unable to report profile"
msgstr "Unable to report profile"

#: src/components/report-modal.jsx:206
msgid "What's the issue with this post?"
msgstr "What's the issue with this post?"

#: src/components/report-modal.jsx:207
msgid "What's the issue with this profile?"
msgstr "What's the issue with this profile?"

#: src/components/report-modal.jsx:276
msgid "Additional info"
msgstr "Additional info"

#: src/components/report-modal.jsx:299
msgid "Forward to <0>{domain}</0>"
msgstr "Forward to <0>{domain}</0>"

#: src/components/report-modal.jsx:309
msgid "Send Report"
msgstr "Send Report"

#: src/components/report-modal.jsx:318
msgid "Muted {username}"
msgstr "Muted {username}"

#: src/components/report-modal.jsx:321
msgid "Unable to mute {username}"
msgstr "Unable to mute {username}"

#: src/components/report-modal.jsx:326
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Send Report <0>+ Mute profile</0>"

#: src/components/report-modal.jsx:337
msgid "Blocked {username}"
msgstr "Blocked {username}"

#: src/components/report-modal.jsx:340
msgid "Unable to block {username}"
msgstr "Unable to block {username}"

#: src/components/report-modal.jsx:345
msgid "Send Report <0>+ Block profile</0>"
msgstr "Send Report <0>+ Block profile</0>"

#: src/components/search-form.jsx:18
msgid "Posts with <0>{query}</0>"
msgstr "Posts with <0>{query}</0>"

#: src/components/search-form.jsx:26
msgid "Accounts with <0>{query}</0>"
msgstr "Accounts with <0>{query}</0>"

#: src/components/search-form.jsx:37
msgid "Posts tagged with <0>{hashtag}</0>"
msgstr "Posts tagged with <0>{hashtag}</0>"

#: src/components/search-form.jsx:46
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ accounts, hashtags & posts</0>"

#: src/components/search-form.jsx:139
msgid "Look up <0>{query}</0>"
msgstr "Look up <0>{query}</0>"

#: src/components/search-form.jsx:366
#: src/pages/home.jsx:251
msgid "See all"
msgstr "See all"

#: src/components/shortcuts-settings.jsx:50
msgid "Home / Following"
msgstr "Home / Following"

#: src/components/shortcuts-settings.jsx:53
msgid "Local / Bubble / Federated"
msgstr "Local / Bubble / Federated"

#: src/components/shortcuts-settings.jsx:55
msgid "Account"
msgstr "Account"

#: src/components/shortcuts-settings.jsx:58
msgid "Hashtag"
msgstr "Hashtag"

#: src/components/shortcuts-settings.jsx:66
msgid "List ID"
msgstr "List ID"

#: src/components/shortcuts-settings.jsx:73
msgid "Type"
msgstr "Type"

#: src/components/shortcuts-settings.jsx:92
#: src/components/shortcuts-settings.jsx:101
#: src/components/shortcuts-settings.jsx:139
#: src/pages/login.jsx:231
msgid "Server"
msgstr "Server"

#: src/components/shortcuts-settings.jsx:95
#: src/components/shortcuts-settings.jsx:104
#: src/components/shortcuts-settings.jsx:142
msgid "Optional, e.g. mastodon.social"
msgstr "Optional, e.g. mastodon.social"

#: src/components/shortcuts-settings.jsx:110
msgid "Search term"
msgstr "Search term"

#: src/components/shortcuts-settings.jsx:113
msgid "Optional, unless for multi-column mode"
msgstr "Optional, unless for multi-column mode"

#: src/components/shortcuts-settings.jsx:130
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "e.g. PixelArt (Max 5, space-separated)"

#: src/components/shortcuts-settings.jsx:134
#: src/pages/hashtag.jsx:389
msgid "Media only"
msgstr "Media only"

#: src/components/shortcuts-settings.jsx:283
#: src/components/shortcuts.jsx:341
msgid "Shortcuts"
msgstr "Shortcuts"

#: src/components/shortcuts-settings.jsx:291
msgid "beta"
msgstr "beta"

#: src/components/shortcuts-settings.jsx:297
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Specify a list of shortcuts that'll appear as:"

#: src/components/shortcuts-settings.jsx:303
msgid "Floating button"
msgstr "Floating button"

#: src/components/shortcuts-settings.jsx:308
msgid "Tab/Menu bar"
msgstr "Tab/Menu bar"

#: src/components/shortcuts-settings.jsx:313
msgid "Multi-column"
msgstr "Multi-column"

#: src/components/shortcuts-settings.jsx:380
msgid "Not available in current view mode"
msgstr "Not available in current view mode"

#: src/components/shortcuts-settings.jsx:399
#: src/pages/accounts.jsx:217
msgid "Move up"
msgstr "Move up"

#: src/components/shortcuts-settings.jsx:415
#: src/pages/accounts.jsx:232
msgid "Move down"
msgstr "Move down"

#: src/components/shortcuts-settings.jsx:427
#: src/components/status.jsx:1615
#: src/pages/list.jsx:195
msgid "Edit"
msgstr "Edit"

#: src/components/shortcuts-settings.jsx:448
msgid "Add more than one shortcut/column to make this work."
msgstr "Add more than one shortcut/column to make this work."

#: src/components/shortcuts-settings.jsx:459
msgid "No columns yet. Tap on the Add column button."
msgstr "No columns yet. Tap on the Add column button."

#: src/components/shortcuts-settings.jsx:460
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "No shortcuts yet. Tap on the Add shortcut button."

#: src/components/shortcuts-settings.jsx:463
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."

#: src/components/shortcuts-settings.jsx:491
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Max {SHORTCUTS_LIMIT} columns"

#: src/components/shortcuts-settings.jsx:492
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Max {SHORTCUTS_LIMIT} shortcuts"

#: src/components/shortcuts-settings.jsx:506
#: src/pages/accounts.jsx:358
msgid "Import/export"
msgstr "Import/export"

#: src/components/shortcuts-settings.jsx:516
msgid "Add column…"
msgstr "Add column…"

#: src/components/shortcuts-settings.jsx:517
msgid "Add shortcut…"
msgstr "Add shortcut…"

#: src/components/shortcuts-settings.jsx:564
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."

#: src/components/shortcuts-settings.jsx:565
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "For multi-column mode, search term is required, else the column will not be shown."

#: src/components/shortcuts-settings.jsx:566
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Multiple hashtags are supported. Space-separated."

#: src/components/shortcuts-settings.jsx:635
msgid "Edit shortcut"
msgstr "Edit shortcut"

#: src/components/shortcuts-settings.jsx:635
msgid "Add shortcut"
msgstr "Add shortcut"

#: src/components/shortcuts-settings.jsx:671
msgid "Timeline"
msgstr "Timeline"

#: src/components/shortcuts-settings.jsx:705
msgid "List"
msgstr "List"

#: src/components/shortcuts-settings.jsx:751
msgid "Variant"
msgstr "Variant"

#: src/components/shortcuts-settings.jsx:896
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Import/Export <0>Shortcuts</0>"

#: src/components/shortcuts-settings.jsx:914
msgid "Paste shortcuts here"
msgstr "Paste shortcuts here"

#: src/components/shortcuts-settings.jsx:950
msgid "Downloading saved shortcuts from server…"
msgstr "Downloading saved shortcuts from server…"

#: src/components/shortcuts-settings.jsx:978
msgid "Unable to download shortcuts"
msgstr "Unable to download shortcuts"

#: src/components/shortcuts-settings.jsx:981
msgid "Download shortcuts from server"
msgstr "Download shortcuts from server"

#: src/components/shortcuts-settings.jsx:1048
msgid "* Exists in current shortcuts"
msgstr "* Exists in current shortcuts"

#: src/components/shortcuts-settings.jsx:1053
msgid "List may not work if it's from a different account."
msgstr "List may not work if it's from a different account."

#: src/components/shortcuts-settings.jsx:1063
msgid "Invalid settings format"
msgstr "Invalid settings format"

#: src/components/shortcuts-settings.jsx:1071
msgid "Append to current shortcuts?"
msgstr "Append to current shortcuts?"

#: src/components/shortcuts-settings.jsx:1074
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Only shortcuts that don’t exist in current shortcuts will be appended."

#: src/components/shortcuts-settings.jsx:1096
msgid "No new shortcuts to import"
msgstr "No new shortcuts to import"

#: src/components/shortcuts-settings.jsx:1111
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."

#: src/components/shortcuts-settings.jsx:1112
#: src/components/shortcuts-settings.jsx:1136
msgid "Shortcuts imported"
msgstr "Shortcuts imported"

#: src/components/shortcuts-settings.jsx:1122
msgid "Import & append…"
msgstr "Import & append…"

#: src/components/shortcuts-settings.jsx:1130
msgid "Override current shortcuts?"
msgstr "Override current shortcuts?"

#: src/components/shortcuts-settings.jsx:1131
msgid "Import shortcuts?"
msgstr "Import shortcuts?"

#: src/components/shortcuts-settings.jsx:1145
msgid "or override…"
msgstr "or override…"

#: src/components/shortcuts-settings.jsx:1145
msgid "Import…"
msgstr "Import…"

#: src/components/shortcuts-settings.jsx:1169
msgid "Shortcuts copied"
msgstr "Shortcuts copied"

#: src/components/shortcuts-settings.jsx:1172
msgid "Unable to copy shortcuts"
msgstr "Unable to copy shortcuts"

#: src/components/shortcuts-settings.jsx:1224
msgid "Saving shortcuts to server…"
msgstr "Saving shortcuts to server…"

#: src/components/shortcuts-settings.jsx:1231
msgid "Shortcuts saved"
msgstr "Shortcuts saved"

#: src/components/shortcuts-settings.jsx:1236
msgid "Unable to save shortcuts"
msgstr "Unable to save shortcuts"

#: src/components/shortcuts-settings.jsx:1239
msgid "Sync to server"
msgstr "Sync to server"

#: src/components/shortcuts-settings.jsx:1254
msgid "Shortcut settings copied"
msgstr "Shortcut settings copied"

#: src/components/shortcuts-settings.jsx:1257
msgid "Unable to copy shortcut settings"
msgstr "Unable to copy shortcut settings"

#: src/components/shortcuts-settings.jsx:1287
msgid "Share"
msgstr "Share"

#. placeholder {0}: shortcutsStr.length
#: src/components/shortcuts-settings.jsx:1293
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural, one {# character} other {# characters}}"

#: src/components/shortcuts-settings.jsx:1305
msgid "Raw Shortcuts JSON"
msgstr "Raw Shortcuts JSON"

#: src/components/shortcuts-settings.jsx:1318
msgid "Import/export settings from/to server (Very experimental)"
msgstr "Import/export settings from/to server (Very experimental)"

#: src/components/status.jsx:288
msgid "Private posts cannot be quoted"
msgstr "Private posts cannot be quoted"

#: src/components/status.jsx:289
msgid "Request to quote"
msgstr "Request to quote"

#: src/components/status.jsx:290
msgid "Author will manually review"
msgstr "Author will manually review"

#: src/components/status.jsx:291
msgid "Only followers can quote this post"
msgstr "Only followers can quote this post"

#: src/components/status.jsx:292
msgid "You are not allowed to quote this post"
msgstr "You are not allowed to quote this post"

#: src/components/status.jsx:368
#: src/components/status.jsx:3169
#: src/components/status.jsx:3170
#: src/components/status.jsx:3171
msgid "Post unavailable"
msgstr "Post unavailable"

#: src/components/status.jsx:629
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>boosted</1>"

#: src/components/status.jsx:736
msgid "Sorry, your current logged-in server can't interact with this post from another server."
msgstr "Sorry, your current logged-in server can't interact with this post from another server."

#. placeholder {0}: username || acct
#: src/components/status.jsx:925
msgid "Unliked @{0}'s post"
msgstr "Unliked @{0}'s post"

#. placeholder {0}: username || acct
#: src/components/status.jsx:926
msgid "Liked @{0}'s post"
msgstr "Liked @{0}'s post"

#. placeholder {0}: username || acct
#: src/components/status.jsx:965
msgid "Unbookmarked @{0}'s post"
msgstr "Unbookmarked @{0}'s post"

#. placeholder {0}: username || acct
#: src/components/status.jsx:966
msgid "Bookmarked @{0}'s post"
msgstr "Bookmarked @{0}'s post"

#: src/components/status.jsx:1070
msgid "Some media have no descriptions."
msgstr "Some media have no descriptions."

#. placeholder {0}: rtf.format(-statusMonthsAgo, 'month')
#: src/components/status.jsx:1077
msgid "Old post (<0>{0}</0>)"
msgstr "Old post (<0>{0}</0>)"

#: src/components/status.jsx:1098
msgid "Reply…"
msgstr "Reply…"

#: src/components/status.jsx:1107
#: src/components/status.jsx:1116
msgid "Reply all"
msgstr "Reply all"

#: src/components/status.jsx:1110
msgid "{mentionsCount, plural, other {# mentions}}"
msgstr "{mentionsCount, plural, other {# mentions}}"

#. placeholder {0}: mentionsCount - 1
#. placeholder {1}: username || acct
#: src/components/status.jsx:1119
msgid "{0, plural, other {<0>@{1}</0> first, # others below}}"
msgstr "{0, plural, other {<0>@{1}</0> first, # others below}}"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1136
msgid "Only <0>@{0}</0>"
msgstr "Only <0>@{0}</0>"

#: src/components/status.jsx:1169
#: src/components/status.jsx:1246
#: src/components/status.jsx:2908
#: src/components/status.jsx:2972
msgid "Unboost"
msgstr "Unboost"

#: src/components/status.jsx:1208
#: src/components/status.jsx:2957
msgid "Quote with link"
msgstr "Quote with link"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1225
#: src/components/status.jsx:1804
msgid "Unboosted @{0}'s post"
msgstr "Unboosted @{0}'s post"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1226
#: src/components/status.jsx:1805
msgid "Boosted @{0}'s post"
msgstr "Boosted @{0}'s post"

#: src/components/status.jsx:1248
#: src/components/status.jsx:2971
msgid "Boost/Quote…"
msgstr "Boost/Quote…"

#: src/components/status.jsx:1249
#: src/components/status.jsx:2971
msgid "Boost…"
msgstr "Boost…"

#: src/components/status.jsx:1261
#: src/components/status.jsx:2140
#: src/components/status.jsx:2991
msgid "Unlike"
msgstr "Unlike"

#: src/components/status.jsx:1262
#: src/components/status.jsx:2140
#: src/components/status.jsx:2141
#: src/components/status.jsx:2991
#: src/components/status.jsx:2992
msgid "Like"
msgstr "Like"

#: src/components/status.jsx:1271
#: src/components/status.jsx:3003
msgid "Unbookmark"
msgstr "Unbookmark"

#: src/components/status.jsx:1306
msgid "View Quotes"
msgstr "View Quotes"

#: src/components/status.jsx:1318
msgid "Unwrap quote chain"
msgstr "Unwrap quote chain"

#: src/components/status.jsx:1385
msgid "Post text copied"
msgstr "Post text copied"

#: src/components/status.jsx:1388
msgid "Unable to copy post text"
msgstr "Unable to copy post text"

#: src/components/status.jsx:1394
msgid "Copy post text"
msgstr "Copy post text"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1412
msgid "View post by <0>@{0}</0>"
msgstr "View post by <0>@{0}</0>"

#: src/components/status.jsx:1433
msgid "Show Edit History"
msgstr "Show Edit History"

#: src/components/status.jsx:1436
msgid "Edited: {editedDateText}"
msgstr "Edited: {editedDateText}"

#: src/components/status.jsx:1519
msgid "Conversation unmuted"
msgstr "Conversation unmuted"

#: src/components/status.jsx:1519
msgid "Conversation muted"
msgstr "Conversation muted"

#: src/components/status.jsx:1525
msgid "Unable to unmute conversation"
msgstr "Unable to unmute conversation"

#: src/components/status.jsx:1526
msgid "Unable to mute conversation"
msgstr "Unable to mute conversation"

#: src/components/status.jsx:1535
msgid "Unmute conversation"
msgstr "Unmute conversation"

#: src/components/status.jsx:1542
msgid "Mute conversation"
msgstr "Mute conversation"

#: src/components/status.jsx:1558
msgid "Post unpinned from profile"
msgstr "Post unpinned from profile"

#: src/components/status.jsx:1559
msgid "Post pinned to profile"
msgstr "Post pinned to profile"

#: src/components/status.jsx:1564
msgid "Unable to unpin post"
msgstr "Unable to unpin post"

#: src/components/status.jsx:1564
msgid "Unable to pin post"
msgstr "Unable to pin post"

#: src/components/status.jsx:1573
msgid "Unpin from profile"
msgstr "Unpin from profile"

#: src/components/status.jsx:1580
msgid "Pin to profile"
msgstr "Pin to profile"

#: src/components/status.jsx:1593
#: src/pages/settings.jsx:303
msgid "Quote settings"
msgstr "Quote settings"

#: src/components/status.jsx:1626
msgid "Delete this post?"
msgstr "Delete this post?"

#: src/components/status.jsx:1642
msgid "Post deleted"
msgstr "Post deleted"

#: src/components/status.jsx:1645
msgid "Unable to delete post"
msgstr "Unable to delete post"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1670
msgid "Remove my post from <0>@{0}</0>'s post?"
msgstr "Remove my post from <0>@{0}</0>'s post?"

#: src/components/status.jsx:1691
msgid "Quote removed"
msgstr "Quote removed"

#: src/components/status.jsx:1695
msgid "Unable to remove quote"
msgstr "Unable to remove quote"

#: src/components/status.jsx:1701
msgid "Remove quote…"
msgstr "Remove quote…"

#: src/components/status.jsx:1715
msgid "Report post…"
msgstr "Report post…"

#: src/components/status.jsx:2141
#: src/components/status.jsx:2177
#: src/components/status.jsx:2992
msgid "Liked"
msgstr "Liked"

#: src/components/status.jsx:2174
#: src/components/status.jsx:2974
msgid "Boosted"
msgstr "Boosted"

#: src/components/status.jsx:2184
#: src/components/status.jsx:3004
msgid "Bookmarked"
msgstr "Bookmarked"

#: src/components/status.jsx:2188
msgid "Pinned"
msgstr "Pinned"

#: src/components/status.jsx:2245
#: src/components/status.jsx:2748
msgid "Deleted"
msgstr "Deleted"

#: src/components/status.jsx:2283
#: src/components/status.jsx:2350
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# reply} other {# replies}}"

#: src/components/status.jsx:2295
#: src/components/status.jsx:2362
#: src/components/status.jsx:2780
msgid "Edited"
msgstr "Edited"

#: src/components/status.jsx:2458
#: src/components/status.jsx:2520
#: src/components/status.jsx:2627
msgid "Show less"
msgstr "Show less"

#: src/components/status.jsx:2458
#: src/components/status.jsx:2520
msgid "Show content"
msgstr "Show content"

#. placeholder {0}: filterInfo.titlesStr
#. placeholder {0}: filterInfo?.titlesStr
#: src/components/status.jsx:2623
#: src/pages/catchup.jsx:2032
msgid "Filtered: {0}"
msgstr "Filtered: {0}"

#: src/components/status.jsx:2627
msgid "Show media"
msgstr "Show media"

#: src/components/status.jsx:2866
#: src/components/status.jsx:2878
msgid "Comments"
msgstr "Comments"

#: src/components/status.jsx:3167
msgid "Post hidden by your filters"
msgstr "Post hidden by your filters"

#: src/components/status.jsx:3168
msgid "Post pending"
msgstr "Post pending"

#: src/components/status.jsx:3172
msgid "Post removed by author"
msgstr "Post removed by author"

#: src/components/status.jsx:3173
msgid "Post hidden because you've blocked @{name}."
msgstr "Post hidden because you've blocked @{name}."

#: src/components/status.jsx:3175
msgid "Post hidden because you've blocked {domain}."
msgstr "Post hidden because you've blocked {domain}."

#: src/components/status.jsx:3176
msgid "Post hidden because you've muted @{name}."
msgstr "Post hidden because you've muted @{name}."

#: src/components/status.jsx:3251
msgid "Show anyway"
msgstr "Show anyway"

#: src/components/status.jsx:3396
msgid "Edit History"
msgstr "Edit History"

#: src/components/status.jsx:3400
msgid "Failed to load history"
msgstr "Failed to load history"

#: src/components/status.jsx:3405
msgid "Loading…"
msgstr "Loading…"

#. [Name] [Visibility icon] boosted
#: src/components/status.jsx:3537
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> boosted"

#: src/components/thread-badge.jsx:22
#: src/components/thread-badge.jsx:37
#: src/components/thread-badge.jsx:52
#: src/pages/catchup.jsx:2050
msgid "Thread"
msgstr "Thread"

#: src/components/thread-badge.jsx:28
msgid "Thread {index}/{total}"
msgstr "Thread {index}/{total}"

#. X is the unspecified total number of posts in a thread
#: src/components/thread-badge.jsx:32
msgid "Thread {index}/X"
msgstr "Thread {index}/X"

#. index/total posts in a thread
#: src/components/thread-badge.jsx:41
msgid "{index}/{total}"
msgstr "{index}/{total}"

#. X is the unspecified total number of posts in a thread
#: src/components/thread-badge.jsx:46
msgid "{index}/X"
msgstr "{index}/X"

#: src/components/timeline.jsx:508
#: src/pages/settings.jsx:1289
msgid "New posts"
msgstr "New posts"

#: src/components/timeline.jsx:609
#: src/pages/home.jsx:228
#: src/pages/notifications.jsx:991
#: src/pages/status.jsx:1240
#: src/pages/status.jsx:1714
msgid "Try again"
msgstr "Try again"

#. placeholder {0}: fItems.length
#: src/components/timeline.jsx:644
msgid "{0, plural, one {# Boost} other {# Boosts}}"
msgstr "{0, plural, one {# Boost} other {# Boosts}}"

#: src/components/timeline.jsx:649
msgid "Pinned posts"
msgstr "Pinned posts"

#. placeholder {0}: filterInfo.titlesStr
#: src/components/timeline.jsx:1002
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Filtered</0>: <1>{0}</1>"

#: src/components/translated-bio-sheet.jsx:26
msgid "Translated Bio"
msgstr "Translated Bio"

#: src/components/translation-block.jsx:226
msgid "Auto-translated from {sourceLangText}"
msgstr "Auto-translated from {sourceLangText}"

#: src/components/translation-block.jsx:265
msgid "Translating…"
msgstr "Translating…"

#: src/components/translation-block.jsx:268
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Translate from {sourceLangText} (auto-detected)"

#: src/components/translation-block.jsx:269
msgid "Translate from {sourceLangText}"
msgstr "Translate from {sourceLangText}"

#. placeholder {0}: detectedLang ?? '…'
#: src/components/translation-block.jsx:297
msgid "Auto ({0})"
msgstr "Auto ({0})"

#: src/components/translation-block.jsx:310
msgid "Failed to translate"
msgstr "Failed to translate"

#: src/compose.jsx:37
msgid "Editing source status"
msgstr "Editing source status"

#. placeholder {0}: replyToStatus.account?.acct || replyToStatus.account?.username
#: src/compose.jsx:39
msgid "Replying to @{0}"
msgstr "Replying to @{0}"

#: src/compose.jsx:67
msgid "You may close this page now."
msgstr "You may close this page now."

#: src/compose.jsx:75
msgid "Close window"
msgstr "Close window"

#: src/compose.jsx:91
msgid "Login required."
msgstr "Login required."

#: src/compose.jsx:95
#: src/pages/annual-report.jsx:186
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:309
msgid "Go home"
msgstr "Go home"

#: src/pages/account-statuses.jsx:272
msgid "Account posts"
msgstr "Account posts"

#: src/pages/account-statuses.jsx:279
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ Replies)"

#: src/pages/account-statuses.jsx:281
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- Boosts)"

#: src/pages/account-statuses.jsx:283
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:285
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Media)"

#: src/pages/account-statuses.jsx:291
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:366
msgid "Clear filters"
msgstr "Clear filters"

#: src/pages/account-statuses.jsx:397
msgid "Showing post with replies"
msgstr "Showing post with replies"

#: src/pages/account-statuses.jsx:402
msgid "+ Replies"
msgstr "+ Replies"

#: src/pages/account-statuses.jsx:416
msgid "Showing posts without boosts"
msgstr "Showing posts without boosts"

#: src/pages/account-statuses.jsx:421
msgid "- Boosts"
msgstr "- Boosts"

#: src/pages/account-statuses.jsx:435
msgid "Showing posts with media"
msgstr "Showing posts with media"

#. placeholder {0}: tag.name
#: src/pages/account-statuses.jsx:460
msgid "Showing posts tagged with #{0}"
msgstr "Showing posts tagged with #{0}"

#. placeholder {0}: date.toLocaleString( i18n.locale, { month: 'long', year: 'numeric', }, )
#: src/pages/account-statuses.jsx:500
msgid "Showing posts in {0}"
msgstr "Showing posts in {0}"

#. placeholder {0}: account?.username
#: src/pages/account-statuses.jsx:547
msgid "Search @{0}'s posts"
msgstr "Search @{0}'s posts"

#: src/pages/account-statuses.jsx:593
#: src/pages/search.jsx:345
#: src/pages/search.jsx:492
msgid "Posts"
msgstr "Posts"

#: src/pages/account-statuses.jsx:618
msgid "Nothing to see here yet."
msgstr "Nothing to see here yet."

#: src/pages/account-statuses.jsx:619
#: src/pages/public.jsx:152
#: src/pages/trending.jsx:452
msgid "Unable to load posts"
msgstr "Unable to load posts"

#: src/pages/account-statuses.jsx:660
#: src/pages/account-statuses.jsx:690
msgid "Unable to fetch account info"
msgstr "Unable to fetch account info"

#. placeholder {0}: accountInstance ? ( <> {' '} (<b>{punycode.toUnicode(accountInstance)}</b>) </> ) : null
#: src/pages/account-statuses.jsx:667
msgid "Switch to account's server {0}"
msgstr "Switch to account's server {0}"

#: src/pages/account-statuses.jsx:697
msgid "Switch to my server (<0>{currentInstance}</0>)"
msgstr "Switch to my server (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:770
msgid "Month"
msgstr "Month"

#: src/pages/accounts.jsx:85
msgid "Current"
msgstr "Current"

#: src/pages/accounts.jsx:133
msgid "Logged out"
msgstr "Logged out"

#: src/pages/accounts.jsx:139
msgid "Default"
msgstr "Default"

#: src/pages/accounts.jsx:161
msgid "Switch to this account"
msgstr "Switch to this account"

#: src/pages/accounts.jsx:170
msgid "Switch in new tab/window"
msgstr "Switch in new tab/window"

#: src/pages/accounts.jsx:184
msgid "View profile…"
msgstr "View profile…"

#: src/pages/accounts.jsx:202
msgid "Set as default"
msgstr "Set as default"

#. placeholder {0}: account.info.acct
#: src/pages/accounts.jsx:245
msgid "Log out <0>@{0}</0>?"
msgstr "Log out <0>@{0}</0>?"

#. placeholder {0}: account.info.acct
#: src/pages/accounts.jsx:273
msgid "Log out and remove <0>@{0}</0>"
msgstr "Log out and remove <0>@{0}</0>"

#: src/pages/accounts.jsx:285
msgid "Log out…"
msgstr "Log out…"

#. placeholder {0}: account.info.acct
#: src/pages/accounts.jsx:295
msgid "Remove <0>@{0}</0>?"
msgstr "Remove <0>@{0}</0>?"

#: src/pages/accounts.jsx:313
msgid "Remove account…"
msgstr "Remove account…"

#. placeholder {0}: niceDateTime(account.createdAt)
#: src/pages/accounts.jsx:321
msgid "Connected on {0} (<0/>)"
msgstr "Connected on {0} (<0/>)"

#: src/pages/accounts.jsx:338
msgid "Add an existing account"
msgstr "Add an existing account"

#: src/pages/accounts.jsx:345
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."

#: src/pages/bookmarks.jsx:28
msgid "No bookmarks yet. Go bookmark something!"
msgstr "No bookmarks yet. Go bookmark something!"

#: src/pages/bookmarks.jsx:29
msgid "Unable to load bookmarks."
msgstr "Unable to load bookmarks."

#: src/pages/catchup.jsx:57
msgid "last 1 hour"
msgstr "last 1 hour"

#: src/pages/catchup.jsx:58
msgid "last 2 hours"
msgstr "last 2 hours"

#: src/pages/catchup.jsx:59
msgid "last 3 hours"
msgstr "last 3 hours"

#: src/pages/catchup.jsx:60
msgid "last 4 hours"
msgstr "last 4 hours"

#: src/pages/catchup.jsx:61
msgid "last 5 hours"
msgstr "last 5 hours"

#: src/pages/catchup.jsx:62
msgid "last 6 hours"
msgstr "last 6 hours"

#: src/pages/catchup.jsx:63
msgid "last 7 hours"
msgstr "last 7 hours"

#: src/pages/catchup.jsx:64
msgid "last 8 hours"
msgstr "last 8 hours"

#: src/pages/catchup.jsx:65
msgid "last 9 hours"
msgstr "last 9 hours"

#: src/pages/catchup.jsx:66
msgid "last 10 hours"
msgstr "last 10 hours"

#: src/pages/catchup.jsx:67
msgid "last 11 hours"
msgstr "last 11 hours"

#: src/pages/catchup.jsx:68
msgid "last 12 hours"
msgstr "last 12 hours"

#: src/pages/catchup.jsx:69
msgid "beyond 12 hours"
msgstr "beyond 12 hours"

#: src/pages/catchup.jsx:77
msgid "Followed tags"
msgstr "Followed tags"

#: src/pages/catchup.jsx:78
msgid "Groups"
msgstr "Groups"

#: src/pages/catchup.jsx:721
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} quotes {quotes} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} quotes {quotes} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"

#: src/pages/catchup.jsx:1014
#: src/pages/catchup.jsx:1038
msgid "Catch-up <0>beta</0>"
msgstr "Catch-up <0>beta</0>"

#: src/pages/catchup.jsx:1028
#: src/pages/catchup.jsx:1716
msgid "Help"
msgstr "Help"

#: src/pages/catchup.jsx:1044
msgid "What is this?"
msgstr "What is this?"

#: src/pages/catchup.jsx:1047
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."

#: src/pages/catchup.jsx:1058
msgid "Preview of Catch-up UI"
msgstr "Preview of Catch-up UI"

#: src/pages/catchup.jsx:1067
msgid "Let's catch up"
msgstr "Let's catch up"

#: src/pages/catchup.jsx:1072
msgid "Let's catch up on the posts from your followings."
msgstr "Let's catch up on the posts from your followings."

#: src/pages/catchup.jsx:1076
msgid "Show me all posts from…"
msgstr "Show me all posts from…"

#: src/pages/catchup.jsx:1099
msgid "until the max"
msgstr "until the max"

#: src/pages/catchup.jsx:1132
msgid "Catch up"
msgstr "Catch up"

#: src/pages/catchup.jsx:1138
msgid "Overlaps with your last catch-up"
msgstr "Overlaps with your last catch-up"

#. placeholder {0}: dtf.format(new Date(lastCatchupEndAt))
#: src/pages/catchup.jsx:1150
msgid "Until the last catch-up ({0})"
msgstr "Until the last catch-up ({0})"

#: src/pages/catchup.jsx:1159
msgid "Note: your server might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Note: your server might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."

#: src/pages/catchup.jsx:1169
msgid "Previously…"
msgstr "Previously…"

#. placeholder {0}: pc.count
#: src/pages/catchup.jsx:1187
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# post} other {# posts}}"

#: src/pages/catchup.jsx:1197
msgid "Remove this catch-up?"
msgstr "Remove this catch-up?"

#. placeholder {0}: pc.id
#: src/pages/catchup.jsx:1200
msgid "Removing Catch-up {0}"
msgstr "Removing Catch-up {0}"

#. placeholder {0}: pc.id
#: src/pages/catchup.jsx:1204
msgid "Catch-up {0} removed"
msgstr "Catch-up {0} removed"

#: src/pages/catchup.jsx:1218
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Note: Only max 3 will be stored. The rest will be automatically removed."

#: src/pages/catchup.jsx:1233
msgid "Fetching posts…"
msgstr "Fetching posts…"

#: src/pages/catchup.jsx:1236
msgid "This might take a while."
msgstr "This might take a while."

#: src/pages/catchup.jsx:1271
msgid "Reset filters"
msgstr "Reset filters"

#: src/pages/catchup.jsx:1279
#: src/pages/catchup.jsx:1722
msgid "Top links"
msgstr "Top links"

#. placeholder {0}: sharers.map((s) => { const { avatarStatic, displayName } = s; return ( <button type="button" class="plain" style={{ padding: 0, }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); // Reset and filter to author const { id } = s; setSelectedAuthor(id); setSelectedFilterCategory('all'); }} > <Avatar url={avatarStatic} size="s" alt={displayName} /> </button> ); })
#: src/pages/catchup.jsx:1392
msgid "Shared by {0}"
msgstr "Shared by {0}"

#: src/pages/catchup.jsx:1447
#: src/pages/mentions.jsx:235
#: src/pages/search.jsx:330
msgid "All"
msgstr "All"

#. placeholder {0}: authorCountsList.length
#: src/pages/catchup.jsx:1532
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {# author} other {# authors}}"

#: src/pages/catchup.jsx:1544
msgid "Sort"
msgstr "Sort"

#: src/pages/catchup.jsx:1574
msgid "Date"
msgstr "Date"

#: src/pages/catchup.jsx:1579
msgid "Density"
msgstr "Density"

#. js-lingui-explicit-id
#: src/pages/catchup.jsx:1602
msgid "group.filter"
msgstr "Group"

#: src/pages/catchup.jsx:1617
msgid "Authors"
msgstr "Authors"

#: src/pages/catchup.jsx:1618
msgid "None"
msgstr "None"

#: src/pages/catchup.jsx:1634
msgid "Show all authors"
msgstr "Show all authors"

#: src/pages/catchup.jsx:1685
msgid "You don't have to read everything."
msgstr "You don't have to read everything."

#: src/pages/catchup.jsx:1686
msgid "That's all."
msgstr "That's all."

#: src/pages/catchup.jsx:1694
msgid "Back to top"
msgstr "Back to top"

#: src/pages/catchup.jsx:1725
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Links shared by followings, sorted by shared counts, boosts and likes."

#: src/pages/catchup.jsx:1731
msgid "Sort: Density"
msgstr "Sort: Density"

#: src/pages/catchup.jsx:1734
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."

#: src/pages/catchup.jsx:1741
msgid "Group: Authors"
msgstr "Group: Authors"

#: src/pages/catchup.jsx:1744
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "Posts are grouped by authors, sorted by posts count per author."

#: src/pages/catchup.jsx:1791
msgid "Next author"
msgstr "Next author"

#: src/pages/catchup.jsx:1799
msgid "Previous author"
msgstr "Previous author"

#: src/pages/catchup.jsx:1815
msgid "Scroll to top"
msgstr "Scroll to top"

#: src/pages/favourites.jsx:28
msgid "No likes yet. Go like something!"
msgstr "No likes yet. Go like something!"

#: src/pages/favourites.jsx:29
msgid "Unable to load likes."
msgstr "Unable to load likes."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Home and lists"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Public timelines"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Conversations"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Profiles"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Never"

#: src/pages/filters.jsx:104
#: src/pages/filters.jsx:229
msgid "New filter"
msgstr "New filter"

#. placeholder {0}: filters.length
#: src/pages/filters.jsx:152
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {# filter} other {# filters}}"

#: src/pages/filters.jsx:167
msgid "Unable to load filters."
msgstr "Unable to load filters."

#: src/pages/filters.jsx:171
msgid "No filters yet."
msgstr "No filters yet."

#: src/pages/filters.jsx:178
msgid "Add filter"
msgstr "Add filter"

#: src/pages/filters.jsx:229
msgid "Edit filter"
msgstr "Edit filter"

#: src/pages/filters.jsx:346
msgid "Unable to edit filter"
msgstr "Unable to edit filter"

#: src/pages/filters.jsx:347
msgid "Unable to create filter"
msgstr "Unable to create filter"

#: src/pages/filters.jsx:356
msgid "Title"
msgstr "Title"

#: src/pages/filters.jsx:399
msgid "Whole word"
msgstr "Whole word"

#: src/pages/filters.jsx:425
msgid "No keywords. Add one."
msgstr "No keywords. Add one."

#: src/pages/filters.jsx:452
msgid "Add keyword"
msgstr "Add keyword"

#. placeholder {0}: filteredEditKeywords.length
#: src/pages/filters.jsx:456
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# keyword} other {# keywords}}"

#: src/pages/filters.jsx:469
msgid "Filter from…"
msgstr "Filter from…"

#: src/pages/filters.jsx:495
msgid "* Not implemented yet"
msgstr "* Not implemented yet"

#: src/pages/filters.jsx:501
msgid "Status: <0><1/></0>"
msgstr "Status: <0><1/></0>"

#: src/pages/filters.jsx:510
msgid "Change expiry"
msgstr "Change expiry"

#: src/pages/filters.jsx:510
msgid "Expiry"
msgstr "Expiry"

#: src/pages/filters.jsx:529
msgid "Filtered post will be…"
msgstr "Filtered post will be…"

#: src/pages/filters.jsx:540
msgid "obscured (media only)"
msgstr "obscured (media only)"

#: src/pages/filters.jsx:554
msgid "minimized"
msgstr "minimized"

#: src/pages/filters.jsx:564
msgid "hidden"
msgstr "hidden"

#: src/pages/filters.jsx:581
msgid "Delete this filter?"
msgstr "Delete this filter?"

#: src/pages/filters.jsx:594
msgid "Unable to delete filter."
msgstr "Unable to delete filter."

#: src/pages/filters.jsx:627
msgid "Expired"
msgstr "Expired"

#: src/pages/filters.jsx:629
msgid "Expiring <0/>"
msgstr "Expiring <0/>"

#: src/pages/filters.jsx:633
msgid "Never expires"
msgstr "Never expires"

#. placeholder {0}: followedHashtags.length
#: src/pages/followed-hashtags.jsx:71
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# hashtag} other {# hashtags}}"

#: src/pages/followed-hashtags.jsx:86
msgid "Unable to load followed hashtags."
msgstr "Unable to load followed hashtags."

#: src/pages/followed-hashtags.jsx:90
msgid "No hashtags followed yet."
msgstr "No hashtags followed yet."

#: src/pages/following.jsx:158
msgid "Nothing to see here."
msgstr "Nothing to see here."

#: src/pages/following.jsx:159
#: src/pages/list.jsx:109
msgid "Unable to load posts."
msgstr "Unable to load posts."

#: src/pages/hashtag.jsx:57
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (Media only) on {instance}"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} on {instance}"

#: src/pages/hashtag.jsx:60
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (Media only)"

#: src/pages/hashtag.jsx:61
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:210
#: src/pages/public.jsx:147
msgid "This timeline is disabled on this server."
msgstr "This timeline is disabled on this server."

#: src/pages/hashtag.jsx:212
#: src/pages/public.jsx:149
msgid "Login required to see posts from this server."
msgstr "Login required to see posts from this server."

#: src/pages/hashtag.jsx:213
msgid "No one has posted anything with this tag yet."
msgstr "No one has posted anything with this tag yet."

#: src/pages/hashtag.jsx:215
msgid "Unable to load posts with this tag"
msgstr "Unable to load posts with this tag"

#: src/pages/hashtag.jsx:241
msgid "Unfollow #{hashtag}?"
msgstr "Unfollow #{hashtag}?"

#: src/pages/hashtag.jsx:256
msgid "Unfollowed #{hashtag}"
msgstr "Unfollowed #{hashtag}"

#: src/pages/hashtag.jsx:271
msgid "Followed #{hashtag}"
msgstr "Followed #{hashtag}"

#: src/pages/hashtag.jsx:287
msgid "Following…"
msgstr "Following…"

#: src/pages/hashtag.jsx:316
msgid "Unfeatured on profile"
msgstr "Unfeatured on profile"

#: src/pages/hashtag.jsx:330
msgid "Unable to unfeature on profile"
msgstr "Unable to unfeature on profile"

#: src/pages/hashtag.jsx:339
#: src/pages/hashtag.jsx:355
msgid "Featured on profile"
msgstr "Featured on profile"

#: src/pages/hashtag.jsx:427
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"

#: src/pages/hashtag.jsx:430
msgid "Add hashtag"
msgstr "Add hashtag"

#: src/pages/hashtag.jsx:463
msgid "Remove hashtag"
msgstr "Remove hashtag"

#: src/pages/hashtag.jsx:477
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"

#: src/pages/hashtag.jsx:506
msgid "This shortcut already exists"
msgstr "This shortcut already exists"

#: src/pages/hashtag.jsx:509
msgid "Hashtag shortcut added"
msgstr "Hashtag shortcut added"

#: src/pages/hashtag.jsx:515
msgid "Add to Shortcuts"
msgstr "Add to Shortcuts"

#: src/pages/hashtag.jsx:521
#: src/pages/public.jsx:201
#: src/pages/trending.jsx:481
msgid "Enter a new server e.g. \"mastodon.social\""
msgstr "Enter a new server e.g. \"mastodon.social\""

#: src/pages/hashtag.jsx:524
#: src/pages/public.jsx:204
#: src/pages/trending.jsx:484
msgid "Invalid server"
msgstr "Invalid server"

#: src/pages/hashtag.jsx:538
#: src/pages/public.jsx:220
#: src/pages/trending.jsx:496
msgid "Go to another server…"
msgstr "Go to another server…"

#: src/pages/hashtag.jsx:551
#: src/pages/public.jsx:233
#: src/pages/trending.jsx:507
msgid "Go to my server (<0>{currentInstance}</0>)"
msgstr "Go to my server (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:224
msgid "Unable to fetch notifications."
msgstr "Unable to fetch notifications."

#: src/pages/home.jsx:245
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>New</0> <1>Follow Requests</1>"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "Resolving…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "Unable to resolve URL"

#: src/pages/list.jsx:108
msgid "Nothing yet."
msgstr "Nothing yet."

#: src/pages/list.jsx:201
#: src/pages/list.jsx:307
msgid "Manage members"
msgstr "Manage members"

#. placeholder {0}: account.username
#: src/pages/list.jsx:342
msgid "Remove <0>@{0}</0> from list?"
msgstr "Remove <0>@{0}</0> from list?"

#: src/pages/list.jsx:388
msgid "Remove…"
msgstr "Remove…"

#. placeholder {0}: lists.length
#: src/pages/lists.jsx:115
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# list} other {# lists}}"

#: src/pages/lists.jsx:135
msgid "No lists yet."
msgstr "No lists yet."

#: src/pages/login.jsx:125
#: src/pages/login.jsx:137
msgid "Failed to register application"
msgstr "Failed to register application"

#: src/pages/login.jsx:246
msgid "server domain"
msgstr "server domain"

#: src/pages/login.jsx:271
msgid "e.g. “mastodon.social”"
msgstr "e.g. “mastodon.social”"

#: src/pages/login.jsx:282
msgid "Failed to log in. Please try again or try another server."
msgstr "Failed to log in. Please try again or try another server."

#: src/pages/login.jsx:294
msgid "Continue with {selectedInstanceText}"
msgstr "Continue with {selectedInstanceText}"

#: src/pages/login.jsx:295
msgid "Continue"
msgstr "Continue"

#: src/pages/login.jsx:303
msgid "Don't have an account? Create one!"
msgstr "Don't have an account? Create one!"

#: src/pages/mentions.jsx:25
msgid "Private mentions"
msgstr "Private mentions"

#: src/pages/mentions.jsx:221
msgid "Only followings"
msgstr "Only followings"

#: src/pages/mentions.jsx:247
msgid "Private"
msgstr "Private"

#: src/pages/mentions.jsx:258
msgid "No one mentioned you :("
msgstr "No one mentioned you :("

#: src/pages/mentions.jsx:259
msgid "Unable to load mentions."
msgstr "Unable to load mentions."

#: src/pages/notifications.jsx:102
msgid "You don't follow"
msgstr "You don't follow"

#: src/pages/notifications.jsx:103
msgid "Who don't follow you"
msgstr "Who don't follow you"

#: src/pages/notifications.jsx:104
msgid "With a new account"
msgstr "With a new account"

#: src/pages/notifications.jsx:105
msgid "Who unsolicitedly private mention you"
msgstr "Who unsolicitedly private mention you"

#: src/pages/notifications.jsx:106
msgid "Who are limited by server moderators"
msgstr "Who are limited by server moderators"

#: src/pages/notifications.jsx:686
#: src/pages/notifications.jsx:1039
msgid "Notifications settings"
msgstr "Notifications settings"

#: src/pages/notifications.jsx:704
msgid "New notifications"
msgstr "New notifications"

#. placeholder {0}: announcements.length
#: src/pages/notifications.jsx:715
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Announcement} other {Announcements}}"

#: src/pages/notifications.jsx:762
#: src/pages/settings.jsx:1277
msgid "Follow requests"
msgstr "Follow requests"

#. placeholder {0}: followRequests.length
#: src/pages/notifications.jsx:767
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# follow request} other {# follow requests}}"

#. placeholder {0}: notificationsPolicy.summary.pendingRequestsCount
#: src/pages/notifications.jsx:822
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"

#: src/pages/notifications.jsx:905
msgid "Only mentions"
msgstr "Only mentions"

#: src/pages/notifications.jsx:911
msgid "Today"
msgstr "Today"

#: src/pages/notifications.jsx:916
msgid "You're all caught up."
msgstr "You're all caught up."

#: src/pages/notifications.jsx:939
msgid "Yesterday"
msgstr "Yesterday"

#: src/pages/notifications.jsx:987
msgid "Unable to load notifications"
msgstr "Unable to load notifications"

#: src/pages/notifications.jsx:1066
msgid "Notifications settings updated"
msgstr "Notifications settings updated"

#: src/pages/notifications.jsx:1074
msgid "Filter out notifications from people:"
msgstr "Filter out notifications from people:"

#: src/pages/notifications.jsx:1088
msgid "Filter"
msgstr "Filter"

#: src/pages/notifications.jsx:1091
msgid "Ignore"
msgstr "Ignore"

#. placeholder {0}: niceDateTime(updatedAtDate)
#: src/pages/notifications.jsx:1164
msgid "Updated <0>{0}</0>"
msgstr "Updated <0>{0}</0>"

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1232
msgid "View notifications from <0>@{0}</0>"
msgstr "View notifications from <0>@{0}</0>"

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1253
msgid "Notifications from <0>@{0}</0>"
msgstr "Notifications from <0>@{0}</0>"

#. placeholder {0}: request.account.username
#: src/pages/notifications.jsx:1321
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "Notifications from @{0} will not be filtered from now on."

#: src/pages/notifications.jsx:1326
msgid "Unable to accept notification request"
msgstr "Unable to accept notification request"

#: src/pages/notifications.jsx:1331
msgid "Allow"
msgstr "Allow"

#. placeholder {0}: request.account.username
#: src/pages/notifications.jsx:1351
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr "Notifications from @{0} will not show up in Filtered notifications from now on."

#: src/pages/notifications.jsx:1356
msgid "Unable to dismiss notification request"
msgstr "Unable to dismiss notification request"

#: src/pages/notifications.jsx:1361
msgid "Dismiss"
msgstr "Dismiss"

#: src/pages/notifications.jsx:1376
msgid "Dismissed"
msgstr "Dismissed"

#: src/pages/public.jsx:30
msgid "Local timeline ({instance})"
msgstr "Local timeline ({instance})"

#: src/pages/public.jsx:31
msgid "Bubble timeline ({instance})"
msgstr "Bubble timeline ({instance})"

#: src/pages/public.jsx:32
msgid "Federated timeline ({instance})"
msgstr "Federated timeline ({instance})"

#: src/pages/public.jsx:128
msgid "Local timeline"
msgstr "Local timeline"

#: src/pages/public.jsx:129
msgid "Bubble timeline"
msgstr "Bubble timeline"

#: src/pages/public.jsx:130
msgid "Federated timeline"
msgstr "Federated timeline"

#: src/pages/public.jsx:150
msgid "No one has posted anything yet."
msgstr "No one has posted anything yet."

#: src/pages/public.jsx:177
msgid "Switch to Local"
msgstr "Switch to Local"

#: src/pages/public.jsx:185
msgid "Switch to Bubble"
msgstr "Switch to Bubble"

#: src/pages/public.jsx:193
msgid "Switch to Federated"
msgstr "Switch to Federated"

#: src/pages/scheduled-posts.jsx:110
msgid "No scheduled posts."
msgstr "No scheduled posts."

#. Scheduled [in 1 day] ([Thu, Feb 27, 6:30:00 PM])
#. placeholder {0}: niceDateTime(scheduledAt, { formatOpts: { weekday: 'short', second: 'numeric', }, })
#: src/pages/scheduled-posts.jsx:210
msgid "Scheduled <0><1/></0> <2>({0})</2>"
msgstr "Scheduled <0><1/></0> <2>({0})</2>"

#. Scheduled [in 1 day]
#: src/pages/scheduled-posts.jsx:292
msgid "Scheduled <0><1/></0>"
msgstr "Scheduled <0><1/></0>"

#: src/pages/scheduled-posts.jsx:337
msgid "Scheduled post rescheduled"
msgstr "Scheduled post rescheduled"

#: src/pages/scheduled-posts.jsx:344
msgid "Failed to reschedule post"
msgstr "Failed to reschedule post"

#: src/pages/scheduled-posts.jsx:367
msgid "Reschedule"
msgstr "Reschedule"

#: src/pages/scheduled-posts.jsx:373
msgid "Delete scheduled post?"
msgstr "Delete scheduled post?"

#: src/pages/scheduled-posts.jsx:381
msgid "Scheduled post deleted"
msgstr "Scheduled post deleted"

#: src/pages/scheduled-posts.jsx:388
msgid "Failed to delete scheduled post"
msgstr "Failed to delete scheduled post"

#: src/pages/search.jsx:51
msgid "Search: {q} (Posts)"
msgstr "Search: {q} (Posts)"

#: src/pages/search.jsx:54
msgid "Search: {q} (Accounts)"
msgstr "Search: {q} (Accounts)"

#: src/pages/search.jsx:57
msgid "Search: {q} (Hashtags)"
msgstr "Search: {q} (Hashtags)"

#: src/pages/search.jsx:60
msgid "Search: {q}"
msgstr "Search: {q}"

#: src/pages/search.jsx:340
#: src/pages/search.jsx:422
msgid "Hashtags"
msgstr "Hashtags"

#: src/pages/search.jsx:372
#: src/pages/search.jsx:426
#: src/pages/search.jsx:496
msgid "See more"
msgstr "See more"

#: src/pages/search.jsx:398
msgid "See more accounts"
msgstr "See more accounts"

#: src/pages/search.jsx:412
msgid "No accounts found."
msgstr "No accounts found."

#: src/pages/search.jsx:468
msgid "See more hashtags"
msgstr "See more hashtags"

#: src/pages/search.jsx:482
msgid "No hashtags found."
msgstr "No hashtags found."

#: src/pages/search.jsx:526
msgid "See more posts"
msgstr "See more posts"

#: src/pages/search.jsx:540
msgid "No posts found."
msgstr "No posts found."

#: src/pages/search.jsx:585
msgid "Enter your search term or paste a URL above to get started."
msgstr "Enter your search term or paste a URL above to get started."

#: src/pages/settings.jsx:105
msgid "Settings"
msgstr "Settings"

#: src/pages/settings.jsx:114
msgid "Appearance"
msgstr "Appearance"

#: src/pages/settings.jsx:190
msgid "Light"
msgstr "Light"

#: src/pages/settings.jsx:201
msgid "Dark"
msgstr "Dark"

#: src/pages/settings.jsx:214
msgid "Auto"
msgstr "Auto"

#: src/pages/settings.jsx:224
msgid "Text size"
msgstr "Text size"

#: src/pages/settings.jsx:232
msgid "Display language"
msgstr "Display language"

#: src/pages/settings.jsx:240
msgid "Volunteer translations"
msgstr "Volunteer translations"

#: src/pages/settings.jsx:251
msgid "Posting"
msgstr "Posting"

#: src/pages/settings.jsx:257
msgid "Default visibility"
msgstr "Default visibility"

#: src/pages/settings.jsx:258
#: src/pages/settings.jsx:304
#: src/pages/settings.jsx:352
msgid "Synced"
msgstr "Synced"

#: src/pages/settings.jsx:281
msgid "Default visibility updated"
msgstr "Default visibility updated"

#: src/pages/settings.jsx:283
msgid "Failed to update default visibility"
msgstr "Failed to update default visibility"

#: src/pages/settings.jsx:354
msgid "Synced to your server's settings. <0>Go to your server ({instance}) for more settings.</0>"
msgstr "Synced to your server's settings. <0>Go to your server ({instance}) for more settings.</0>"

#: src/pages/settings.jsx:369
msgid "Experiments"
msgstr "Experiments"

#: src/pages/settings.jsx:382
msgid "Auto refresh timeline posts"
msgstr "Auto refresh timeline posts"

#: src/pages/settings.jsx:394
msgid "Boosts carousel"
msgstr "Boosts carousel"

#: src/pages/settings.jsx:411
msgid "Post translation"
msgstr "Post translation"

#: src/pages/settings.jsx:422
msgid "Translate to "
msgstr "Translate to "

#: src/pages/settings.jsx:433
msgid "System language ({systemTargetLanguageText})"
msgstr "System language ({systemTargetLanguageText})"

#. placeholder {0}: snapStates.settings.contentTranslationHideLanguages .length
#: src/pages/settings.jsx:459
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"

#: src/pages/settings.jsx:514
msgid "Note: This feature uses external translation services, powered by <0>{TRANSLATION_API_NAME}</0>."
msgstr "Note: This feature uses external translation services, powered by <0>{TRANSLATION_API_NAME}</0>."

#: src/pages/settings.jsx:542
msgid "Auto inline translation"
msgstr "Auto inline translation"

#: src/pages/settings.jsx:546
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."

#: src/pages/settings.jsx:567
msgid "GIF Picker for composer"
msgstr "GIF Picker for composer"

#: src/pages/settings.jsx:571
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."

#: src/pages/settings.jsx:600
msgid "Image description generator"
msgstr "Image description generator"

#: src/pages/settings.jsx:605
msgid "Only for new images while composing new posts."
msgstr "Only for new images while composing new posts."

#: src/pages/settings.jsx:612
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."

#: src/pages/settings.jsx:640
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "\"Cloud\" import/export for shortcuts settings"

#: src/pages/settings.jsx:645
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."

#: src/pages/settings.jsx:656
msgid "Note: This feature uses currently-logged-in server API."
msgstr "Note: This feature uses currently-logged-in server API."

#: src/pages/settings.jsx:672
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"

#: src/pages/settings.jsx:681
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "Replace text as blocks, useful when taking screenshots, for privacy reasons."

#: src/pages/settings.jsx:710
msgid "Install {CLIENT_NAME}"
msgstr "Install {CLIENT_NAME}"

#: src/pages/settings.jsx:718
msgid "About"
msgstr "About"

#: src/pages/settings.jsx:757
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<0>Built</0> by <1>@cheeaun</1>"

#: src/pages/settings.jsx:786
msgid "Sponsor"
msgstr "Sponsor"

#: src/pages/settings.jsx:794
msgid "Donate"
msgstr "Donate"

#: src/pages/settings.jsx:810
msgid "What's new"
msgstr "What's new"

#: src/pages/settings.jsx:814
msgid "Privacy Policy"
msgstr "Privacy Policy"

#. placeholder {0}: WEBSITE.replace(/https?:\/\//g, '').replace(/\/$/, '')
#: src/pages/settings.jsx:821
msgid "<0>Site:</0> {0}"
msgstr "<0>Site:</0> {0}"

#. placeholder {0}: !__FAKE_COMMIT_HASH__ && ( <span class="ib insignificant"> ( <a href={`https://github.com/cheeaun/phanpy/commit/${__COMMIT_HASH__}`} target="_blank" rel="noopener" > <RelativeTime datetime={new Date(__BUILD_TIME__)} /> </a> ) </span> )
#: src/pages/settings.jsx:828
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Version:</0> <1/> {0}"

#: src/pages/settings.jsx:843
msgid "Version string copied"
msgstr "Version string copied"

#: src/pages/settings.jsx:846
msgid "Unable to copy version string"
msgstr "Unable to copy version string"

#. Preview of one character, in largest size
#. Preview of one character, in smallest size
#: src/pages/settings.jsx:990
#: src/pages/settings.jsx:1014
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:1174
#: src/pages/settings.jsx:1179
msgid "Failed to update subscription. Please try again."
msgstr "Failed to update subscription. Please try again."

#: src/pages/settings.jsx:1185
msgid "Failed to remove subscription. Please try again."
msgstr "Failed to remove subscription. Please try again."

#: src/pages/settings.jsx:1192
msgid "Push Notifications (beta)"
msgstr "Push Notifications (beta)"

#: src/pages/settings.jsx:1214
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "Push notifications are blocked. Please enable them in your browser settings."

#. placeholder {0}: [ { value: 'all', label: t`anyone`, }, { value: 'followed', label: t`people I follow`, }, { value: 'follower', label: t`followers`, }, ].map((type) => ( <option value={type.value}>{type.label}</option> ))
#: src/pages/settings.jsx:1223
msgid "Allow from <0>{0}</0>"
msgstr "Allow from <0>{0}</0>"

#: src/pages/settings.jsx:1232
msgid "anyone"
msgstr "anyone"

#: src/pages/settings.jsx:1236
msgid "people I follow"
msgstr "people I follow"

#: src/pages/settings.jsx:1240
msgid "followers"
msgstr "followers"

#: src/pages/settings.jsx:1273
msgid "Follows"
msgstr "Follows"

#: src/pages/settings.jsx:1281
msgid "Polls"
msgstr "Polls"

#: src/pages/settings.jsx:1285
msgid "Post edits"
msgstr "Post edits"

#: src/pages/settings.jsx:1306
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."

#: src/pages/settings.jsx:1322
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "NOTE: Push notifications only work for <0>one account</0>."

#. js-lingui-explicit-id
#: src/pages/status.jsx:791
#: src/pages/status.jsx:1465
msgid "post.title"
msgstr "Post"

#: src/pages/status.jsx:1068
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "You're not logged in. Interactions (reply, boost, etc) are not possible."

#: src/pages/status.jsx:1088
msgid "This post is from another server (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "This post is from another server (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."

#: src/pages/status.jsx:1116
msgid "Error: {e}"
msgstr "Error: {e}"

#: src/pages/status.jsx:1123
msgid "Switch to my server to enable interactions"
msgstr "Switch to my server to enable interactions"

#: src/pages/status.jsx:1231
msgid "Unable to load replies."
msgstr "Unable to load replies."

#: src/pages/status.jsx:1287
msgid "{months, plural, one {# month later} other {# months later}}"
msgstr "{months, plural, one {# month later} other {# months later}}"

#: src/pages/status.jsx:1293
msgid "{years, plural, one {# year later} other {# years later}}"
msgstr "{years, plural, one {# year later} other {# years later}}"

#: src/pages/status.jsx:1425
msgid "Back"
msgstr "Back"

#: src/pages/status.jsx:1456
msgid "Go to main post"
msgstr "Go to main post"

#. placeholder {0}: ancestors.length
#: src/pages/status.jsx:1479
msgid "{0} posts above ‒ Go to top"
msgstr "{0} posts above ‒ Go to top"

#: src/pages/status.jsx:1528
#: src/pages/status.jsx:1591
msgid "Switch to Side Peek view"
msgstr "Switch to Side Peek view"

#: src/pages/status.jsx:1592
msgid "Switch to Full view"
msgstr "Switch to Full view"

#: src/pages/status.jsx:1610
msgid "Show all sensitive content"
msgstr "Show all sensitive content"

#: src/pages/status.jsx:1615
msgid "Experimental"
msgstr "Experimental"

#: src/pages/status.jsx:1624
msgid "Unable to switch"
msgstr "Unable to switch"

#. placeholder {0}: punycode.toUnicode( postInstance, )
#: src/pages/status.jsx:1631
msgid "Switch to post's server ({0})"
msgstr "Switch to post's server ({0})"

#: src/pages/status.jsx:1634
msgid "Switch to post's server"
msgstr "Switch to post's server"

#: src/pages/status.jsx:1647
msgid "View Edit History Snapshots"
msgstr "View Edit History Snapshots"

#: src/pages/status.jsx:1705
msgid "Unable to load post"
msgstr "Unable to load post"

#. placeholder {0}: replies.length
#. placeholder {1}: shortenNumber(replies.length)
#: src/pages/status.jsx:1842
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, one {# reply} other {<0>{1}</0> replies}}"

#. placeholder {0}: shortenNumber(totalComments)
#: src/pages/status.jsx:1860
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"

#: src/pages/status.jsx:1882
msgid "View post with its replies"
msgstr "View post with its replies"

#: src/pages/trending.jsx:77
msgid "Trending ({instance})"
msgstr "Trending ({instance})"

#: src/pages/trending.jsx:235
msgid "Trending News"
msgstr "Trending News"

#. By [Author]
#. placeholder {0}: author ? ( <NameText account={author} showAvatar /> ) : authorUrl ? ( <a href={authorUrl} target="_blank" rel="noopener" > {authorName} </a> ) : ( authorName )
#: src/pages/trending.jsx:350
msgid "By {0}"
msgstr "By {0}"

#: src/pages/trending.jsx:411
msgid "Back to showing trending posts"
msgstr "Back to showing trending posts"

#. placeholder {0}: currentLink .replace(/^https?:\/\/(www\.)?/i, '') .replace(/\/$/, '')
#: src/pages/trending.jsx:416
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "Showing posts mentioning <0>{0}</0>"

#: src/pages/trending.jsx:428
msgid "Trending posts"
msgstr "Trending posts"

#: src/pages/trending.jsx:451
msgid "No trending posts."
msgstr "No trending posts."

#: src/pages/welcome.jsx:52
msgid "A minimalistic opinionated Mastodon web client."
msgstr "A minimalistic opinionated Mastodon web client."

#: src/pages/welcome.jsx:63
msgid "Log in with Mastodon"
msgstr "Log in with Mastodon"

#: src/pages/welcome.jsx:69
msgid "Sign up"
msgstr "Sign up"

#: src/pages/welcome.jsx:76
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."

#: src/pages/welcome.jsx:96
msgid "Screenshot of Phanpy home timeline on mobile device"
msgstr "Screenshot of Phanpy home timeline on mobile device"

#: src/pages/welcome.jsx:113
msgid "Screenshot of Phanpy home timeline on tablet device"
msgstr "Screenshot of Phanpy home timeline on tablet device"

#: src/pages/welcome.jsx:127
msgid "Screenshot of Boosts Carousel"
msgstr "Screenshot of Boosts Carousel"

#: src/pages/welcome.jsx:134
msgid "Boosts Carousel"
msgstr "Boosts Carousel"

#: src/pages/welcome.jsx:137
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Visually separate original posts and re-shared posts (boosted posts)."

#: src/pages/welcome.jsx:147
msgid "Screenshot of Catch-up"
msgstr "Screenshot of Catch-up"

#: src/pages/welcome.jsx:157
msgid "A separate timeline for followings. Email-inspired interface to sort and filter posts."
msgstr "A separate timeline for followings. Email-inspired interface to sort and filter posts."

#: src/pages/welcome.jsx:167
msgid "Screenshot of nested comments thread"
msgstr "Screenshot of nested comments thread"

#: src/pages/welcome.jsx:174
msgid "Nested comments thread"
msgstr "Nested comments thread"

#: src/pages/welcome.jsx:177
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Effortlessly follow conversations. Semi-collapsible replies."

#: src/pages/welcome.jsx:186
msgid "Screenshot of multi-column UI"
msgstr "Screenshot of multi-column UI"

#: src/pages/welcome.jsx:193
msgid "Single or multi-column"
msgstr "Single or multi-column"

#: src/pages/welcome.jsx:196
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "By default, single column for zen-mode seekers. Configurable multi-column for power users."

#: src/pages/welcome.jsx:206
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr "Screenshot of multi-hashtag timeline with a form to add more hashtags"

#: src/pages/welcome.jsx:213
msgid "Multi-hashtag timeline"
msgstr "Multi-hashtag timeline"

#: src/pages/welcome.jsx:216
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Up to 5 hashtags combined into a single timeline."

#: src/pages/welcome.jsx:231
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Looks like your browser is blocking popups."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "A draft post is currently minimized. Post or discard it before creating a new one."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "A post is currently open. Post or discard it before creating a new one."
